function PlanLL({ ...props }) {
	return (
		<g {...props} id="unit-ll">
			<g id="furniture">
				<polyline
					points="731.43 563.79 729.51 563.79 729.51 560.01 731.43 560.01 731.43 563.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="458.4"
					y1="636.57"
					x2="458.4"
					y2="607.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.4"
					y1="607.84"
					x2="534.74"
					y2="607.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.74"
					y1="607.84"
					x2="534.74"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.74"
					y1="636.57"
					x2="531.04"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.28"
					y1="636.57"
					x2="523.69"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.93"
					y1="636.57"
					x2="516.33"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.51"
					y1="636.57"
					x2="486.92"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.16"
					y1="636.57"
					x2="479.56"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.8"
					y1="636.57"
					x2="472.21"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.45"
					y1="636.57"
					x2="464.85"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="462.1"
					y1="636.57"
					x2="458.4"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.4"
					y1="636.57"
					x2="458.4"
					y2="631.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.4"
					y1="629.13"
					x2="458.4"
					y2="624.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.4"
					y1="621.78"
					x2="458.4"
					y2="617.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.4"
					y1="614.43"
					x2="458.4"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.4"
					y1="609.75"
					x2="462.1"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.85"
					y1="609.75"
					x2="469.45"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.21"
					y1="609.75"
					x2="476.8"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.56"
					y1="609.75"
					x2="484.16"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.92"
					y1="609.75"
					x2="491.51"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.27"
					y1="609.75"
					x2="498.87"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.62"
					y1="609.75"
					x2="506.22"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.98"
					y1="609.75"
					x2="513.57"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.33"
					y1="609.75"
					x2="520.93"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.69"
					y1="609.75"
					x2="528.28"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.04"
					y1="609.75"
					x2="534.74"
					y2="609.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.74"
					y1="609.75"
					x2="534.74"
					y2="614.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.74"
					y1="617.18"
					x2="534.74"
					y2="621.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.74"
					y1="624.54"
					x2="534.74"
					y2="629.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.74"
					y1="631.89"
					x2="534.74"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="934.68 459.78 934.68 565.08 905.95 565.08 905.95 459.78 934.68 459.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="934.68"
					y1="459.78"
					x2="934.68"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="565.08"
					x2="905.95"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.95"
					y1="565.08"
					x2="905.95"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.95"
					y1="459.78"
					x2="934.68"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="459.78"
					x2="934.68"
					y2="463.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="466.01"
					x2="934.68"
					y2="470.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="473.36"
					x2="934.68"
					y2="477.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="480.72"
					x2="934.68"
					y2="485.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="488.07"
					x2="934.68"
					y2="492.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="495.42"
					x2="934.68"
					y2="500.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="502.78"
					x2="934.68"
					y2="507.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="510.13"
					x2="934.68"
					y2="514.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="517.49"
					x2="934.68"
					y2="522.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="524.84"
					x2="934.68"
					y2="529.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="532.19"
					x2="934.68"
					y2="536.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="539.55"
					x2="934.68"
					y2="544.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="546.9"
					x2="934.68"
					y2="551.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="554.25"
					x2="934.68"
					y2="558.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="561.61"
					x2="934.68"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="565.08"
					x2="930.01"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="927.25"
					y1="565.08"
					x2="922.65"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.89"
					y1="565.08"
					x2="915.3"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="912.54"
					y1="565.08"
					x2="907.87"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="565.08"
					x2="907.87"
					y2="561.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="558.85"
					x2="907.87"
					y2="554.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="551.5"
					x2="907.87"
					y2="546.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="544.14"
					x2="907.87"
					y2="539.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="536.79"
					x2="907.87"
					y2="532.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="529.43"
					x2="907.87"
					y2="524.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="522.08"
					x2="907.87"
					y2="517.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="514.73"
					x2="907.87"
					y2="510.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="507.37"
					x2="907.87"
					y2="502.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="500.02"
					x2="907.87"
					y2="495.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="492.66"
					x2="907.87"
					y2="488.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="485.31"
					x2="907.87"
					y2="480.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="477.96"
					x2="907.87"
					y2="473.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="470.6"
					x2="907.87"
					y2="466.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="463.25"
					x2="907.87"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.87"
					y1="459.78"
					x2="912.54"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.3"
					y1="459.78"
					x2="919.89"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.65"
					y1="459.78"
					x2="927.25"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="930.01"
					y1="459.78"
					x2="934.68"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.32"
					y1="420.65"
					x2="208.38"
					y2="420.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.38"
					y1="449.38"
					x2="204.41"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.66"
					y1="449.38"
					x2="197.06"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.3"
					y1="449.38"
					x2="189.71"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="186.95"
					y1="449.38"
					x2="182.35"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="179.59"
					y1="449.38"
					x2="175"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.24"
					y1="449.38"
					x2="167.64"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="164.89"
					y1="449.38"
					x2="160.29"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.53"
					y1="449.38"
					x2="152.94"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.18"
					y1="449.38"
					x2="145.58"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="142.82"
					y1="449.38"
					x2="138.23"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="135.47"
					y1="449.38"
					x2="130.87"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.32"
					y1="434.59"
					x2="65.32"
					y2="430"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.32"
					y1="427.24"
					x2="65.32"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.32"
					y1="422.57"
					x2="69.28"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.04"
					y1="422.57"
					x2="76.64"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="79.4"
					y1="422.57"
					x2="83.99"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.75"
					y1="422.57"
					x2="91.35"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="94.1"
					y1="422.57"
					x2="98.7"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="101.46"
					y1="422.57"
					x2="106.05"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.81"
					y1="422.57"
					x2="113.41"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.17"
					y1="422.57"
					x2="120.76"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="123.52"
					y1="422.57"
					x2="128.12"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="130.87"
					y1="422.57"
					x2="135.47"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="138.23"
					y1="422.57"
					x2="142.82"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="145.58"
					y1="422.57"
					x2="150.18"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="152.94"
					y1="422.57"
					x2="157.53"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="160.29"
					y1="422.57"
					x2="164.89"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="167.64"
					y1="422.57"
					x2="172.24"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="175"
					y1="422.57"
					x2="179.59"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="182.35"
					y1="422.57"
					x2="186.95"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="422.57"
					x2="194.3"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.06"
					y1="422.57"
					x2="201.66"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.41"
					y1="422.57"
					x2="208.38"
					y2="422.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.38"
					y1="422.57"
					x2="208.38"
					y2="427.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.38"
					y1="437.35"
					x2="208.38"
					y2="441.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.38"
					y1="444.7"
					x2="208.38"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="359.42 581.69 411.13 581.69 411.13 633.4 359.42 633.4 359.42 581.69"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="113.63 121.41 113.63 125.55 146.84 125.55 146.84 121.41 113.63 121.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="148.35 121.03 112.13 121.03 112.13 121.41 148.35 121.41 148.35 121.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="148.35"
					y1="121.41"
					x2="148.35"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.41"
					x2="148.35"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.03"
					x2="112.13"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.35"
					y1="121.03"
					x2="112.13"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="125.55"
					x2="146.84"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.84"
					y1="121.41"
					x2="113.63"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="110.24 125.55 113.63 125.55 113.63 121.41 110.24 121.41 110.24 125.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="110.24"
					y1="121.41"
					x2="110.24"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="121.41"
					x2="110.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="125.55"
					x2="113.63"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.24"
					y1="125.55"
					x2="113.63"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="150.24 121.41 146.84 121.41 146.84 125.55 150.24 125.55 150.24 121.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="150.24"
					y1="125.55"
					x2="150.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.84"
					y1="125.55"
					x2="150.24"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.84"
					y1="121.41"
					x2="146.84"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.24"
					y1="121.41"
					x2="146.84"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="122.16"
					x2="146.84"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="108.73 125.18 110.24 125.18 110.24 121.41 112.13 121.41 112.13 121.03 108.73 121.03 108.73 125.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="108.73"
					y1="121.03"
					x2="108.73"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.03"
					x2="108.73"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.41"
					x2="112.13"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.24"
					y1="121.41"
					x2="112.13"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.24"
					y1="125.18"
					x2="110.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.73"
					y1="125.18"
					x2="110.24"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="151.74 121.03 148.35 121.03 148.35 121.41 150.24 121.41 150.24 125.18 151.74 125.18 151.74 121.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="151.74"
					y1="125.18"
					x2="151.74"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.24"
					y1="125.18"
					x2="151.74"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.24"
					y1="121.41"
					x2="150.24"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.35"
					y1="121.41"
					x2="150.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.35"
					y1="121.03"
					x2="148.35"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.74"
					y1="121.03"
					x2="148.35"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="153.66 122.16 153.66 124.07 253.5 124.07 253.5 122.16 153.66 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="253.5"
					y1="122.16"
					x2="153.66"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.5"
					y1="124.07"
					x2="253.5"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.66"
					y1="124.07"
					x2="253.5"
					y2="124.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.66"
					y1="122.16"
					x2="153.66"
					y2="124.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="108.73 122.16 108.73 133.65 104.9 133.65 104.9 122.16 108.73 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="108.73"
					y1="133.65"
					x2="108.73"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.9"
					y1="133.65"
					x2="108.73"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.9"
					y1="122.16"
					x2="104.9"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.73"
					y1="122.16"
					x2="104.9"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="155.57 122.16 155.57 133.65 151.74 133.65 151.74 122.16 155.57 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="155.57"
					y1="133.65"
					x2="155.57"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.74"
					y1="133.65"
					x2="155.57"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.74"
					y1="122.16"
					x2="151.74"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="155.57"
					y1="122.16"
					x2="151.74"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="255.42 122.16 255.42 133.65 251.59 133.65 251.59 122.16 255.42 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="255.42"
					y1="133.65"
					x2="255.42"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.59"
					y1="133.65"
					x2="255.42"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.59"
					y1="122.16"
					x2="251.59"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.42"
					y1="122.16"
					x2="251.59"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="670.83 274.7 670.83 278.85 704.04 278.85 704.04 274.7 670.83 274.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="705.55 274.32 669.32 274.32 669.32 274.7 705.55 274.7 705.55 274.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="705.55"
					y1="274.7"
					x2="705.55"
					y2="274.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.32"
					y1="274.7"
					x2="705.55"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.32"
					y1="274.32"
					x2="669.32"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.55"
					y1="274.32"
					x2="669.32"
					y2="274.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.83"
					y1="278.85"
					x2="704.04"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.04"
					y1="274.7"
					x2="670.83"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="667.44 278.85 670.83 278.85 670.83 274.7 667.44 274.7 667.44 278.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="667.44"
					y1="274.7"
					x2="667.44"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.83"
					y1="274.7"
					x2="667.44"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.83"
					y1="278.85"
					x2="670.83"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.44"
					y1="278.85"
					x2="670.83"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="707.43 274.7 704.04 274.7 704.04 278.85 707.43 278.85 707.43 274.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="707.43"
					y1="278.85"
					x2="707.43"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.04"
					y1="278.85"
					x2="707.43"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.04"
					y1="274.7"
					x2="704.04"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.43"
					y1="274.7"
					x2="704.04"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.83"
					y1="275.46"
					x2="704.04"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="665.93 278.47 667.44 278.47 667.44 274.7 669.32 274.7 669.32 274.32 665.93 274.32 665.93 278.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="665.93"
					y1="274.32"
					x2="665.93"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.32"
					y1="274.32"
					x2="665.93"
					y2="274.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.32"
					y1="274.7"
					x2="669.32"
					y2="274.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.44"
					y1="274.7"
					x2="669.32"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.44"
					y1="278.47"
					x2="667.44"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.93"
					y1="278.47"
					x2="667.44"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="708.94 274.32 705.55 274.32 705.55 274.7 707.43 274.7 707.43 278.47 708.94 278.47 708.94 274.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="708.94"
					y1="278.47"
					x2="708.94"
					y2="274.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.43"
					y1="278.47"
					x2="708.94"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.43"
					y1="274.7"
					x2="707.43"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.55"
					y1="274.7"
					x2="707.43"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.55"
					y1="274.32"
					x2="705.55"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.94"
					y1="274.32"
					x2="705.55"
					y2="274.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="710.86 275.46 710.86 277.37 810.7 277.37 810.7 275.46 710.86 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="810.7"
					y1="275.46"
					x2="710.86"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.7"
					y1="277.37"
					x2="810.7"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.86"
					y1="277.37"
					x2="810.7"
					y2="277.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.86"
					y1="275.46"
					x2="710.86"
					y2="277.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="665.93 275.46 665.93 286.95 662.1 286.95 662.1 275.46 665.93 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="665.93"
					y1="286.95"
					x2="665.93"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.1"
					y1="286.95"
					x2="665.93"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.1"
					y1="275.46"
					x2="662.1"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="665.93"
					y1="275.46"
					x2="662.1"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="712.77 275.46 712.77 286.95 708.94 286.95 708.94 275.46 712.77 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="712.77"
					y1="286.95"
					x2="712.77"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.94"
					y1="286.95"
					x2="712.77"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.94"
					y1="275.46"
					x2="708.94"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.77"
					y1="275.46"
					x2="708.94"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="812.61 275.46 812.61 286.95 808.79 286.95 808.79 275.46 812.61 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="812.61"
					y1="286.95"
					x2="812.61"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.78"
					y1="286.95"
					x2="812.61"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.78"
					y1="275.46"
					x2="808.78"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.61"
					y1="275.46"
					x2="808.78"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="559.73 265.65 559.73 214.03 563.5 214.03 563.5 265.65 559.73 265.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="559.73"
					y1="265.65"
					x2="559.73"
					y2="214.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.73"
					y1="214.03"
					x2="563.5"
					y2="214.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="214.03"
					x2="563.5"
					y2="265.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="265.65"
					x2="559.73"
					y2="265.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.75"
					y1="265.65"
					x2="562.75"
					y2="214.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="265.65"
					x2="563.5"
					y2="214.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.73"
					y1="265.65"
					x2="559.73"
					y2="214.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="559.73 274.7 559.73 265.65 563.5 265.65 563.5 274.7 559.73 274.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="559.73"
					y1="274.7"
					x2="559.73"
					y2="265.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.73"
					y1="265.65"
					x2="563.5"
					y2="265.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="265.65"
					x2="563.5"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="274.7"
					x2="559.73"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="559.73 214.03 559.73 204.98 563.5 204.98 563.5 214.03 559.73 214.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="559.73"
					y1="214.03"
					x2="559.73"
					y2="204.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.73"
					y1="204.98"
					x2="563.5"
					y2="204.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="204.98"
					x2="563.5"
					y2="214.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="214.03"
					x2="559.73"
					y2="214.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="565.01 278.85 561.61 278.85 561.61 278.47 563.5 278.47 563.5 274.7 565.01 274.7 565.01 278.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="565.01"
					y1="278.85"
					x2="561.61"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.61"
					y1="278.85"
					x2="561.61"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.61"
					y1="278.47"
					x2="563.5"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="278.47"
					x2="563.5"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.5"
					y1="274.7"
					x2="565.01"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.01"
					y1="274.7"
					x2="565.01"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="492.28 274.7 493.78 274.7 493.78 278.47 495.67 278.47 495.67 278.85 492.28 278.85 492.28 274.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="492.28"
					y1="274.7"
					x2="493.78"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.78"
					y1="274.7"
					x2="493.78"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.78"
					y1="278.47"
					x2="495.67"
					y2="278.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.67"
					y1="278.47"
					x2="495.67"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.67"
					y1="278.85"
					x2="492.28"
					y2="278.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.28"
					y1="278.85"
					x2="492.28"
					y2="274.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="490.36 275.46 490.36 277.37 420.68 277.37 420.68 275.46 490.36 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="490.36"
					y1="275.46"
					x2="490.36"
					y2="277.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.36"
					y1="277.37"
					x2="420.68"
					y2="277.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.68"
					y1="277.37"
					x2="420.68"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.68"
					y1="275.46"
					x2="490.36"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="565.01 275.46 568.84 275.46 568.84 286.95 565.01 286.95 565.01 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="568.84"
					y1="275.46"
					x2="565.01"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.84"
					y1="286.95"
					x2="568.84"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.01"
					y1="286.95"
					x2="568.84"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.01"
					y1="275.46"
					x2="565.01"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="488.45 275.46 492.28 275.46 492.28 286.95 488.45 286.95 488.45 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="492.28"
					y1="275.46"
					x2="488.45"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.28"
					y1="286.95"
					x2="492.28"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.45"
					y1="286.95"
					x2="492.28"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.45"
					y1="275.46"
					x2="488.45"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="418.76 275.46 422.59 275.46 422.59 286.95 418.76 286.95 418.76 275.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="422.59"
					y1="275.46"
					x2="418.76"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.59"
					y1="286.95"
					x2="422.59"
					y2="275.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.76"
					y1="286.95"
					x2="422.59"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.76"
					y1="275.46"
					x2="418.76"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="113.63 121.41 113.63 125.55 146.84 125.55 146.84 121.41 113.63 121.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="148.35 121.03 112.13 121.03 112.13 121.41 148.35 121.41 148.35 121.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="148.35"
					y1="121.41"
					x2="148.35"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.41"
					x2="148.35"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.03"
					x2="112.13"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.35"
					y1="121.03"
					x2="112.13"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="125.55"
					x2="146.84"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.84"
					y1="121.41"
					x2="113.63"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="110.24 125.55 113.63 125.55 113.63 121.41 110.24 121.41 110.24 125.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="110.24"
					y1="121.41"
					x2="110.24"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="121.41"
					x2="110.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="125.55"
					x2="113.63"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.24"
					y1="125.55"
					x2="113.63"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="150.24 121.41 146.84 121.41 146.84 125.55 150.24 125.55 150.24 121.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="150.24"
					y1="125.55"
					x2="150.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.84"
					y1="125.55"
					x2="150.24"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="146.84"
					y1="121.41"
					x2="146.84"
					y2="125.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.24"
					y1="121.41"
					x2="146.84"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.63"
					y1="122.16"
					x2="146.84"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="108.73 125.18 110.24 125.18 110.24 121.41 112.13 121.41 112.13 121.03 108.73 121.03 108.73 125.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="108.73"
					y1="121.03"
					x2="108.73"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.03"
					x2="108.73"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.13"
					y1="121.41"
					x2="112.13"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.24"
					y1="121.41"
					x2="112.13"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.24"
					y1="125.18"
					x2="110.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.73"
					y1="125.18"
					x2="110.24"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="151.74 121.03 148.35 121.03 148.35 121.41 150.24 121.41 150.24 125.18 151.74 125.18 151.74 121.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="151.74"
					y1="125.18"
					x2="151.74"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.24"
					y1="125.18"
					x2="151.74"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.24"
					y1="121.41"
					x2="150.24"
					y2="125.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.35"
					y1="121.41"
					x2="150.24"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="148.35"
					y1="121.03"
					x2="148.35"
					y2="121.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.74"
					y1="121.03"
					x2="148.35"
					y2="121.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="153.66 122.16 153.66 124.07 253.5 124.07 253.5 122.16 153.66 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="253.5"
					y1="122.16"
					x2="153.66"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.5"
					y1="124.07"
					x2="253.5"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.66"
					y1="124.07"
					x2="253.5"
					y2="124.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.66"
					y1="122.16"
					x2="153.66"
					y2="124.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="108.73 122.16 108.73 133.65 104.9 133.65 104.9 122.16 108.73 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="108.73"
					y1="133.65"
					x2="108.73"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.9"
					y1="133.65"
					x2="108.73"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.9"
					y1="122.16"
					x2="104.9"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.73"
					y1="122.16"
					x2="104.9"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="155.57 122.16 155.57 133.65 151.74 133.65 151.74 122.16 155.57 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="155.57"
					y1="133.65"
					x2="155.57"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.74"
					y1="133.65"
					x2="155.57"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="151.74"
					y1="122.16"
					x2="151.74"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="155.57"
					y1="122.16"
					x2="151.74"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="255.42 122.16 255.42 133.65 251.59 133.65 251.59 122.16 255.42 122.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="255.42"
					y1="133.65"
					x2="255.42"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.59"
					y1="133.65"
					x2="255.42"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.59"
					y1="122.16"
					x2="251.59"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.42"
					y1="122.16"
					x2="251.59"
					y2="122.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="880.71"
					x2="826.31"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="865.39"
					x2="826.31"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="865.39"
					x2="829.18"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="880.71"
					x2="904.83"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="865.39"
					x2="904.83"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="865.39"
					x2="901.96"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="901 881.67 904.83 881.67 904.83 880.71 901 880.71 901 881.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="830.14 880.71 826.31 880.71 826.31 881.67 830.14 881.67 830.14 880.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="901 865.39 904.83 865.39 904.83 864.43 901 864.43 901 865.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="830.14 864.43 826.31 864.43 826.31 865.39 830.14 865.39 830.14 864.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="901"
					y1="881.67"
					x2="904.83"
					y2="881.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.83"
					y1="881.67"
					x2="904.83"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.83"
					y1="880.71"
					x2="901"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901"
					y1="880.71"
					x2="901"
					y2="881.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.14"
					y1="880.71"
					x2="826.31"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.31"
					y1="880.71"
					x2="826.31"
					y2="881.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.31"
					y1="881.67"
					x2="830.14"
					y2="881.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.14"
					y1="881.67"
					x2="830.14"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901"
					y1="865.39"
					x2="904.83"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.83"
					y1="865.39"
					x2="904.83"
					y2="864.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.83"
					y1="864.43"
					x2="901"
					y2="864.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901"
					y1="864.43"
					x2="901"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.14"
					y1="864.43"
					x2="826.31"
					y2="864.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.31"
					y1="864.43"
					x2="826.31"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.31"
					y1="865.39"
					x2="830.14"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="830.14"
					y1="865.39"
					x2="830.14"
					y2="864.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="900.04 880.71 901.48 880.71 901.48 865.39 900.04 865.39 900.04 880.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="829.66 880.71 831.1 880.71 831.1 865.39 829.66 865.39 829.66 880.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="879.85 816.64 831.1 865.39 833.47 867.76 882.22 819.01 879.85 816.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="901.48"
					y1="865.39"
					x2="901.96"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.48"
					y1="880.71"
					x2="901.96"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="865.39"
					x2="901.96"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.66"
					y1="865.39"
					x2="829.18"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.66"
					y1="880.71"
					x2="829.18"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="865.39"
					x2="829.18"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.04"
					y1="880.71"
					x2="900.04"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.04"
					y1="865.39"
					x2="901.48"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.48"
					y1="865.39"
					x2="901.48"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.48"
					y1="880.71"
					x2="900.04"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.66"
					y1="880.71"
					x2="829.66"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.66"
					y1="865.39"
					x2="831.1"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.1"
					y1="865.39"
					x2="831.1"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.1"
					y1="880.71"
					x2="829.66"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.85"
					y1="816.64"
					x2="882.22"
					y2="819.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.22"
					y1="819.01"
					x2="833.47"
					y2="867.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.47"
					y1="867.76"
					x2="831.1"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.1"
					y1="865.39"
					x2="879.85"
					y2="816.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="865.39"
					x2="901.96"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="865.39"
					x2="901.96"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="865.39"
					x2="904.83"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="865.39"
					x2="904.83"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="880.71"
					x2="904.83"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.96"
					y1="880.71"
					x2="904.83"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="865.39"
					x2="829.18"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="865.39"
					x2="829.18"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="865.39"
					x2="826.31"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="865.39"
					x2="826.31"
					y2="865.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="880.71"
					x2="826.31"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.18"
					y1="880.71"
					x2="826.31"
					y2="880.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="459.78"
					x2="934.68"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="459.78"
					x2="934.68"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.61"
					y1="271.63"
					x2="812.61"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.36"
					y1="271.63"
					x2="354.36"
					y2="118.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.42"
					y1="118.33"
					x2="255.42"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.74"
					y1="573.43"
					x2="205.34"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.74"
					y1="636.57"
					x2="218.74"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.81"
					y1="636.57"
					x2="727.6"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="636.57"
					x2="218.74"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="439.26"
					x2="348.61"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="339.03"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="348.61"
					y2="439.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="377.98"
					x2="348.61"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="377.98"
					x2="339.03"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="377.98"
					x2="348.61"
					y2="377.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="468.55"
					x2="348.61"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="468.55"
					x2="339.03"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="468.55"
					x2="348.61"
					y2="468.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="529.84"
					x2="348.61"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.84"
					x2="339.03"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.84"
					x2="348.61"
					y2="529.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="339.03"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="458.95"
					x2="339.03"
					y2="468.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="636.57"
					x2="348.61"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="349.57 378.94 349.57 375.11 348.61 375.11 348.61 378.94 349.57 378.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="348.61 438.3 348.61 442.14 349.57 442.14 349.57 438.3 348.61 438.3"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="339.03 378.94 339.03 375.11 338.08 375.11 338.08 378.94 339.03 378.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="338.08 438.3 338.08 442.14 339.03 442.14 339.03 438.3 338.08 438.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="349.57"
					y1="378.94"
					x2="349.57"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.57"
					y1="375.11"
					x2="348.61"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="375.11"
					x2="348.61"
					y2="378.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="378.94"
					x2="349.57"
					y2="378.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="438.3"
					x2="348.61"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="442.14"
					x2="349.57"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.57"
					y1="442.14"
					x2="349.57"
					y2="438.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.57"
					y1="438.3"
					x2="348.61"
					y2="438.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="378.94"
					x2="339.03"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="375.11"
					x2="338.08"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="375.11"
					x2="338.08"
					y2="378.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="378.94"
					x2="339.03"
					y2="378.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="438.3"
					x2="338.08"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="442.14"
					x2="339.03"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="442.14"
					x2="339.03"
					y2="438.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="438.3"
					x2="338.08"
					y2="438.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="348.61 379.89 348.61 378.46 339.03 378.46 339.03 379.89 348.61 379.89"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="348.61 438.78 348.61 437.35 339.03 437.35 339.03 438.78 348.61 438.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="298.41 396.72 339.03 437.35 341.4 434.98 300.78 394.35 298.41 396.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.03"
					y1="378.46"
					x2="339.03"
					y2="377.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="378.46"
					x2="348.61"
					y2="377.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="377.98"
					x2="348.61"
					y2="377.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="438.78"
					x2="339.03"
					y2="439.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="438.78"
					x2="348.61"
					y2="439.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="348.61"
					y2="439.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="379.89"
					x2="339.03"
					y2="379.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="379.89"
					x2="339.03"
					y2="378.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="378.46"
					x2="348.61"
					y2="378.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="378.46"
					x2="348.61"
					y2="379.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="438.78"
					x2="339.03"
					y2="438.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="438.78"
					x2="339.03"
					y2="437.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="437.35"
					x2="348.61"
					y2="437.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="437.35"
					x2="348.61"
					y2="438.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.41"
					y1="396.72"
					x2="300.78"
					y2="394.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.78"
					y1="394.35"
					x2="341.4"
					y2="434.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.4"
					y1="434.98"
					x2="339.03"
					y2="437.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="437.35"
					x2="298.41"
					y2="396.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="377.98"
					x2="348.61"
					y2="377.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="377.98"
					x2="348.61"
					y2="377.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="377.98"
					x2="339.03"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="377.98"
					x2="339.03"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="377.98"
					x2="348.61"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="377.98"
					x2="348.61"
					y2="375.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="348.61"
					y2="439.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="348.61"
					y2="439.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="339.03"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="439.26"
					x2="339.03"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="439.26"
					x2="348.61"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="439.26"
					x2="348.61"
					y2="442.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="349.57 528.88 348.61 528.88 348.61 532.71 349.57 532.71 349.57 528.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="348.61 469.51 349.57 469.51 349.57 465.68 348.61 465.68 348.61 469.51"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="339.03 528.88 338.08 528.88 338.08 532.71 339.03 532.71 339.03 528.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="338.08 469.51 339.03 469.51 339.03 465.68 338.08 465.68 338.08 469.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="349.57"
					y1="528.88"
					x2="349.57"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.57"
					y1="532.71"
					x2="348.61"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="532.71"
					x2="348.61"
					y2="528.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="528.88"
					x2="349.57"
					y2="528.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="469.51"
					x2="348.61"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="465.68"
					x2="349.57"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.57"
					y1="465.68"
					x2="349.57"
					y2="469.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.57"
					y1="469.51"
					x2="348.61"
					y2="469.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="528.88"
					x2="339.03"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="532.71"
					x2="338.08"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="532.71"
					x2="338.08"
					y2="528.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="528.88"
					x2="339.03"
					y2="528.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="469.51"
					x2="338.08"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.08"
					y1="465.68"
					x2="339.03"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="465.68"
					x2="339.03"
					y2="469.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="469.51"
					x2="338.08"
					y2="469.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="348.61 527.92 339.03 527.92 339.03 529.36 348.61 529.36 348.61 527.92"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="348.61 469.03 339.03 469.03 339.03 470.47 348.61 470.47 348.61 469.03"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="298.41 511.1 300.78 513.47 341.4 472.84 339.03 470.47 298.41 511.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.03"
					y1="529.36"
					x2="339.03"
					y2="529.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="529.36"
					x2="348.61"
					y2="529.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.84"
					x2="348.61"
					y2="529.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="469.03"
					x2="339.03"
					y2="468.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="469.03"
					x2="348.61"
					y2="468.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="468.55"
					x2="348.61"
					y2="468.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="527.92"
					x2="339.03"
					y2="527.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="527.92"
					x2="339.03"
					y2="529.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.36"
					x2="348.61"
					y2="529.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="529.36"
					x2="348.61"
					y2="527.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="469.03"
					x2="339.03"
					y2="469.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="469.03"
					x2="339.03"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="470.47"
					x2="348.61"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="470.47"
					x2="348.61"
					y2="469.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.41"
					y1="511.1"
					x2="300.78"
					y2="513.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.78"
					y1="513.47"
					x2="341.4"
					y2="472.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.4"
					y1="472.84"
					x2="339.03"
					y2="470.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="470.47"
					x2="298.41"
					y2="511.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.84"
					x2="348.61"
					y2="529.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.84"
					x2="348.61"
					y2="529.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.84"
					x2="339.03"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="529.84"
					x2="339.03"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="529.84"
					x2="348.61"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="529.84"
					x2="348.61"
					y2="532.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="468.55"
					x2="348.61"
					y2="468.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="468.55"
					x2="348.61"
					y2="468.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="468.55"
					x2="339.03"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="468.55"
					x2="339.03"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="468.55"
					x2="348.61"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="468.55"
					x2="348.61"
					y2="465.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.38"
					y1="449.38"
					x2="205.34"
					y2="449.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="403.76"
					x2="72.08"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="401.84"
					x2="74.48"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="394.18"
					x2="72.08"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="394.18"
					x2="74.48"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="403.76"
					x2="200.4"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="401.84"
					x2="198"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="394.18"
					x2="200.4"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="394.18"
					x2="198"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="394.18"
					x2="65.32"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="65.32"
					y1="403.76"
					x2="74.48"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="196.57 401.84 196.57 403.76 197.52 403.76 197.52 401.84 196.57 401.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="196.57 404.71 200.4 404.71 200.4 403.76 196.57 403.76 196.57 404.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="74.96 401.84 74.96 403.76 75.91 403.76 75.91 401.84 74.96 401.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="75.91 403.76 72.08 403.76 72.08 404.71 75.91 404.71 75.91 403.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="196.57 394.18 200.4 394.18 200.4 391.78 196.57 391.78 196.57 394.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="75.91 391.78 72.08 391.78 72.08 394.18 75.91 394.18 75.91 391.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="196.57"
					y1="401.84"
					x2="196.57"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.57"
					y1="403.76"
					x2="197.52"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.52"
					y1="403.76"
					x2="197.52"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.52"
					y1="401.84"
					x2="196.57"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.57"
					y1="404.71"
					x2="200.4"
					y2="404.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.4"
					y1="404.71"
					x2="200.4"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.4"
					y1="403.76"
					x2="196.57"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.57"
					y1="403.76"
					x2="196.57"
					y2="404.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.96"
					y1="401.84"
					x2="74.96"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.96"
					y1="403.76"
					x2="75.91"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.91"
					y1="403.76"
					x2="75.91"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.91"
					y1="401.84"
					x2="74.96"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.91"
					y1="403.76"
					x2="72.08"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.08"
					y1="403.76"
					x2="72.08"
					y2="404.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.08"
					y1="404.71"
					x2="75.91"
					y2="404.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.91"
					y1="404.71"
					x2="75.91"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.57"
					y1="394.18"
					x2="200.4"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.4"
					y1="394.18"
					x2="200.4"
					y2="391.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.4"
					y1="391.78"
					x2="196.57"
					y2="391.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.57"
					y1="391.78"
					x2="196.57"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.91"
					y1="391.78"
					x2="72.08"
					y2="391.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.08"
					y1="391.78"
					x2="72.08"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="72.08"
					y1="394.18"
					x2="75.91"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="75.91"
					y1="394.18"
					x2="75.91"
					y2="391.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="193.69 401.84 197.52 401.84 197.52 394.18 193.69 394.18 193.69 401.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="74.96 401.84 78.79 401.84 78.79 394.18 74.96 394.18 74.96 401.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="138.16 394.18 78.79 394.18 78.79 397.53 138.16 397.53 138.16 394.18"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="170.71 397.53 111.34 397.53 111.34 400.88 170.71 400.88 170.71 397.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="197.52"
					y1="394.18"
					x2="198"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.52"
					y1="401.84"
					x2="198"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="394.18"
					x2="198"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.96"
					y1="394.18"
					x2="74.48"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.96"
					y1="401.84"
					x2="74.48"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="394.18"
					x2="74.48"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.69"
					y1="401.84"
					x2="193.69"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.69"
					y1="394.18"
					x2="197.52"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.52"
					y1="394.18"
					x2="197.52"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.52"
					y1="401.84"
					x2="193.69"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.96"
					y1="401.84"
					x2="74.96"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.96"
					y1="394.18"
					x2="78.79"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="78.79"
					y1="394.18"
					x2="78.79"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="78.79"
					y1="401.84"
					x2="74.96"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="138.16"
					y1="394.18"
					x2="138.16"
					y2="397.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="138.16"
					y1="397.53"
					x2="78.79"
					y2="397.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="78.79"
					y1="397.53"
					x2="78.79"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="78.79"
					y1="394.18"
					x2="138.16"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.71"
					y1="397.53"
					x2="170.71"
					y2="400.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="170.71"
					y1="400.88"
					x2="111.34"
					y2="400.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.34"
					y1="400.88"
					x2="111.34"
					y2="397.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.34"
					y1="397.53"
					x2="170.71"
					y2="397.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="394.18"
					x2="198"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="394.18"
					x2="198"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="401.84"
					x2="198"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="394.18"
					x2="200.4"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="401.84"
					x2="198"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="403.76"
					x2="200.4"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198"
					y1="403.76"
					x2="200.4"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="394.18"
					x2="74.48"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="394.18"
					x2="74.48"
					y2="401.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="401.84"
					x2="74.48"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="394.18"
					x2="72.08"
					y2="394.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="401.84"
					x2="74.48"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="403.76"
					x2="72.08"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="74.48"
					y1="403.76"
					x2="72.08"
					y2="403.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="580.28"
					x2="464.32"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="570.71"
					x2="464.32"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="570.71"
					x2="467.19"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="580.28"
					x2="531.35"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="570.71"
					x2="531.35"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="570.71"
					x2="528.47"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="580.28"
					x2="351.76"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="351.76"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="354.63"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="580.28"
					x2="418.79"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="570.71"
					x2="418.79"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="570.71"
					x2="415.92"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.61"
					y1="580.28"
					x2="354.63"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="580.28"
					x2="421.94"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.4"
					y1="580.28"
					x2="467.19"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="580.28"
					x2="534.74"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="570.71"
					x2="528.47"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="348.61"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="527.52 581.24 531.35 581.24 531.35 580.28 527.52 580.28 527.52 581.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="468.15 580.28 464.32 580.28 464.32 581.24 468.15 581.24 468.15 580.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="527.52 570.71 531.35 570.71 531.35 569.75 527.52 569.75 527.52 570.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="468.15 569.75 464.32 569.75 464.32 570.71 468.15 570.71 468.15 569.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="527.52"
					y1="581.24"
					x2="531.35"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.35"
					y1="581.24"
					x2="531.35"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.35"
					y1="580.28"
					x2="527.52"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.52"
					y1="580.28"
					x2="527.52"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.15"
					y1="580.28"
					x2="464.32"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.32"
					y1="580.28"
					x2="464.32"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.32"
					y1="581.24"
					x2="468.15"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.15"
					y1="581.24"
					x2="468.15"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.52"
					y1="570.71"
					x2="531.35"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.35"
					y1="570.71"
					x2="531.35"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.35"
					y1="569.75"
					x2="527.52"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.52"
					y1="569.75"
					x2="527.52"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.15"
					y1="569.75"
					x2="464.32"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.32"
					y1="569.75"
					x2="464.32"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.32"
					y1="570.71"
					x2="468.15"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.15"
					y1="570.71"
					x2="468.15"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="526.56 580.28 528 580.28 528 570.71 526.56 570.71 526.56 580.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="467.67 580.28 469.11 580.28 469.11 570.71 467.67 570.71 467.67 580.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="509.73 530.08 469.11 570.71 471.48 573.08 512.1 532.45 509.73 530.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="528"
					y1="570.71"
					x2="528.47"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528"
					y1="580.28"
					x2="528.47"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="570.71"
					x2="528.47"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.67"
					y1="570.71"
					x2="467.19"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.67"
					y1="580.28"
					x2="467.19"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="570.71"
					x2="467.19"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.56"
					y1="580.28"
					x2="526.56"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.56"
					y1="570.71"
					x2="528"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528"
					y1="570.71"
					x2="528"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528"
					y1="580.28"
					x2="526.56"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.67"
					y1="580.28"
					x2="467.67"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.67"
					y1="570.71"
					x2="469.11"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.11"
					y1="570.71"
					x2="469.11"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.11"
					y1="580.28"
					x2="467.67"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="509.73"
					y1="530.08"
					x2="512.1"
					y2="532.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="512.1"
					y1="532.45"
					x2="471.48"
					y2="573.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.48"
					y1="573.08"
					x2="469.11"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.11"
					y1="570.71"
					x2="509.73"
					y2="530.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="570.71"
					x2="528.47"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="570.71"
					x2="528.47"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="570.71"
					x2="531.35"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="570.71"
					x2="531.35"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="580.28"
					x2="531.35"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.47"
					y1="580.28"
					x2="531.35"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="570.71"
					x2="467.19"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="570.71"
					x2="467.19"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="570.71"
					x2="464.32"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="570.71"
					x2="464.32"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="580.28"
					x2="464.32"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.19"
					y1="580.28"
					x2="464.32"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="414.96 581.24 418.79 581.24 418.79 580.28 414.96 580.28 414.96 581.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="355.59 580.28 351.76 580.28 351.76 581.24 355.59 581.24 355.59 580.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="414.96 570.71 418.79 570.71 418.79 569.75 414.96 569.75 414.96 570.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="355.59 569.75 351.76 569.75 351.76 570.71 355.59 570.71 355.59 569.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="414.96"
					y1="581.24"
					x2="418.79"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.79"
					y1="581.24"
					x2="418.79"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.79"
					y1="580.28"
					x2="414.96"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.96"
					y1="580.28"
					x2="414.96"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.59"
					y1="580.28"
					x2="351.76"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="580.28"
					x2="351.76"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="581.24"
					x2="355.59"
					y2="581.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.59"
					y1="581.24"
					x2="355.59"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.96"
					y1="570.71"
					x2="418.79"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.79"
					y1="570.71"
					x2="418.79"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.79"
					y1="569.75"
					x2="414.96"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.96"
					y1="569.75"
					x2="414.96"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.59"
					y1="569.75"
					x2="351.76"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="569.75"
					x2="351.76"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.76"
					y1="570.71"
					x2="355.59"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.59"
					y1="570.71"
					x2="355.59"
					y2="569.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="414 580.28 415.44 580.28 415.44 570.71 414 570.71 414 580.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="355.11 580.28 356.55 580.28 356.55 570.71 355.11 570.71 355.11 580.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="397.17 530.08 356.55 570.71 358.92 573.08 399.54 532.45 397.17 530.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="415.44"
					y1="570.71"
					x2="415.92"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.44"
					y1="580.28"
					x2="415.92"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="570.71"
					x2="415.92"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.11"
					y1="570.71"
					x2="354.63"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.11"
					y1="580.28"
					x2="354.63"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="354.63"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414"
					y1="580.28"
					x2="414"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414"
					y1="570.71"
					x2="415.44"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.44"
					y1="570.71"
					x2="415.44"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.44"
					y1="580.28"
					x2="414"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.11"
					y1="580.28"
					x2="355.11"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="355.11"
					y1="570.71"
					x2="356.55"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.55"
					y1="570.71"
					x2="356.55"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.55"
					y1="580.28"
					x2="355.11"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.17"
					y1="530.08"
					x2="399.54"
					y2="532.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.54"
					y1="532.45"
					x2="358.92"
					y2="573.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.92"
					y1="573.08"
					x2="356.55"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.55"
					y1="570.71"
					x2="397.17"
					y2="530.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="570.71"
					x2="415.92"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="570.71"
					x2="415.92"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="570.71"
					x2="418.79"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="570.71"
					x2="418.79"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="580.28"
					x2="418.79"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="415.92"
					y1="580.28"
					x2="418.79"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="354.63"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="354.63"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="351.76"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="570.71"
					x2="351.76"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="580.28"
					x2="351.76"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.63"
					y1="580.28"
					x2="351.76"
					y2="580.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.74"
					y1="580.28"
					x2="534.74"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="619.12"
					x2="544.31"
					y2="570.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.6"
					y1="636.57"
					x2="727.6"
					y2="619.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="557.63"
					x2="875.65"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="557.63"
					x2="875.65"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.63"
					x2="866.08"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.63"
					x2="873.74"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="467.85"
					x2="875.65"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="467.85"
					x2="875.65"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="467.85"
					x2="866.08"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="467.85"
					x2="873.74"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="459.78"
					x2="866.08"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="565.08"
					x2="875.65"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="467.85"
					x2="875.65"
					y2="459.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="873.74 469.29 875.65 469.29 875.65 468.33 873.74 468.33 873.74 469.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="876.61 469.29 876.61 465.46 875.65 465.46 875.65 469.29 876.61 469.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="873.74 557.15 875.65 557.15 875.65 556.19 873.74 556.19 873.74 557.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="875.65 556.19 875.65 560.02 876.61 560.02 876.61 556.19 875.65 556.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="866.08 469.29 866.08 465.46 863.68 465.46 863.68 469.29 866.08 469.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="863.68 556.19 863.68 560.02 866.08 560.02 866.08 556.19 863.68 556.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="873.74"
					y1="469.29"
					x2="875.65"
					y2="469.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="469.29"
					x2="875.65"
					y2="468.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="468.33"
					x2="873.74"
					y2="468.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="468.33"
					x2="873.74"
					y2="469.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.61"
					y1="469.29"
					x2="876.61"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.61"
					y1="465.46"
					x2="875.65"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="465.46"
					x2="875.65"
					y2="469.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="469.29"
					x2="876.61"
					y2="469.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="557.15"
					x2="875.65"
					y2="557.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="557.15"
					x2="875.65"
					y2="556.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="556.19"
					x2="873.74"
					y2="556.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="556.19"
					x2="873.74"
					y2="557.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="556.19"
					x2="875.65"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="560.02"
					x2="876.61"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.61"
					y1="560.02"
					x2="876.61"
					y2="556.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="876.61"
					y1="556.19"
					x2="875.65"
					y2="556.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="469.29"
					x2="866.08"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="465.46"
					x2="863.68"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.68"
					y1="465.46"
					x2="863.68"
					y2="469.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.68"
					y1="469.29"
					x2="866.08"
					y2="469.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.68"
					y1="556.19"
					x2="863.68"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.68"
					y1="560.02"
					x2="866.08"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="560.02"
					x2="866.08"
					y2="556.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="556.19"
					x2="863.68"
					y2="556.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="873.74 472.16 873.74 468.33 866.08 468.33 866.08 472.16 873.74 472.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="873.74 557.15 873.74 553.32 866.08 553.32 866.08 557.15 873.74 557.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="866.08 510.83 866.08 553.32 869.43 553.32 869.43 510.83 866.08 510.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="869.43 495.14 869.43 537.64 872.78 537.64 872.78 495.14 869.43 495.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="866.08"
					y1="468.33"
					x2="866.08"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="468.33"
					x2="873.74"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="467.85"
					x2="873.74"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.15"
					x2="866.08"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="557.15"
					x2="873.74"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.63"
					x2="873.74"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="472.16"
					x2="866.08"
					y2="472.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="472.16"
					x2="866.08"
					y2="468.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="468.33"
					x2="873.74"
					y2="468.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="468.33"
					x2="873.74"
					y2="472.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="557.15"
					x2="866.08"
					y2="557.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.15"
					x2="866.08"
					y2="553.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="553.32"
					x2="873.74"
					y2="553.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="553.32"
					x2="873.74"
					y2="557.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="510.83"
					x2="869.43"
					y2="510.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.43"
					y1="510.83"
					x2="869.43"
					y2="553.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.43"
					y1="553.32"
					x2="866.08"
					y2="553.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="553.32"
					x2="866.08"
					y2="510.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.43"
					y1="495.14"
					x2="872.78"
					y2="495.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.78"
					y1="495.14"
					x2="872.78"
					y2="537.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.78"
					y1="537.64"
					x2="869.43"
					y2="537.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.43"
					y1="537.64"
					x2="869.43"
					y2="495.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="467.85"
					x2="873.74"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="467.85"
					x2="873.74"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="467.85"
					x2="875.65"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="467.85"
					x2="866.08"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="467.85"
					x2="875.65"
					y2="467.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="467.85"
					x2="875.65"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="467.85"
					x2="875.65"
					y2="465.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.63"
					x2="873.74"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.63"
					x2="873.74"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="557.63"
					x2="875.65"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.08"
					y1="557.63"
					x2="866.08"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.74"
					y1="557.63"
					x2="875.65"
					y2="557.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="557.63"
					x2="875.65"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.65"
					y1="557.63"
					x2="875.65"
					y2="560.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="934.68"
					y1="565.08"
					x2="875.65"
					y2="565.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="881.4 271.63 877.57 271.63 877.57 150.95 881.4 147.12 881.4 271.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="881.4"
					y1="271.63"
					x2="881.4"
					y2="147.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="877.57"
					y1="150.95"
					x2="877.57"
					y2="271.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="877.57"
					y1="271.63"
					x2="881.4"
					y2="271.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<polyline
					points="881.4 147.12 877.57 150.95 354.36 150.95 354.36 147.12 881.4 147.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="881.4"
					y1="147.12"
					x2="354.36"
					y2="147.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="354.36"
					y1="147.12"
					x2="354.36"
					y2="150.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="354.36"
					y1="150.95"
					x2="877.57"
					y2="150.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="418.76"
					y1="286.95"
					x2="418.76"
					y2="271.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.84"
					y1="271.63"
					x2="568.84"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.1"
					y1="286.95"
					x2="662.1"
					y2="271.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="104.9"
					y1="133.65"
					x2="104.9"
					y2="118.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="339.03 636.57 339.03 573.43 218.74 573.43 218.74 636.57 339.03 636.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="218.74"
					y1="636.57"
					x2="339.03"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.74"
					y1="573.43"
					x2="218.74"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="573.43"
					x2="218.74"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.03"
					y1="636.57"
					x2="339.03"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.51"
					y1="632.79"
					x2="335.27"
					y2="632.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.27"
					y1="632.79"
					x2="335.27"
					y2="577.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.27"
					y1="577.2"
					x2="222.51"
					y2="577.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.51"
					y1="577.2"
					x2="222.51"
					y2="632.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.51"
					y1="632.79"
					x2="273.4"
					y2="607.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.51"
					y1="577.2"
					x2="273.4"
					y2="602.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.27"
					y1="632.79"
					x2="284.37"
					y2="607.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.27"
					y1="577.2"
					x2="284.37"
					y2="602.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="278.89"
					y1="608.77"
					x2="278.89"
					y2="601.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.66"
					y1="605"
					x2="275.12"
					y2="605"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m284.92,605c0-3.33-2.7-6.03-6.03-6.03s-6.03,2.7-6.03,6.03,2.7,6.03,6.03,6.03,6.03-2.7,6.03-6.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m282.66,605c0-2.08-1.69-3.77-3.77-3.77s-3.77,1.69-3.77,3.77,1.69,3.77,3.77,3.77,3.77-1.69,3.77-3.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="218.74 605 226.73 610.88 226.73 599.11 218.74 605"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="226.73"
					y1="599.11"
					x2="218.74"
					y2="605"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.73"
					y1="610.88"
					x2="226.73"
					y2="599.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.74"
					y1="605"
					x2="226.73"
					y2="610.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.56"
					y1="605"
					x2="233.47"
					y2="605"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.73"
					y1="605"
					x2="226.73"
					y2="599.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.73"
					y1="599.11"
					x2="218.74"
					y2="605"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.73"
					y1="605"
					x2="226.73"
					y2="610.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.73"
					y1="610.88"
					x2="218.74"
					y2="605"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.41"
					y1="603.26"
					x2="232.67"
					y2="600.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.41"
					y1="606.73"
					x2="232.67"
					y2="609.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="243.63 524.45 205.34 524.45 205.34 573.43 243.63 573.43 243.63 524.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="243.63"
					y1="524.45"
					x2="243.63"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.34"
					y1="524.45"
					x2="205.34"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.63"
					y1="573.43"
					x2="205.34"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.63"
					y1="524.45"
					x2="205.34"
					y2="524.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.85"
					y1="524.45"
					x2="206.85"
					y2="573.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.54"
					y1="529.79"
					x2="234.54"
					y2="568.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="234.54"
					y1="568.09"
					x2="211.56"
					y2="568.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.56"
					y1="568.09"
					x2="211.56"
					y2="529.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.56"
					y1="529.79"
					x2="234.54"
					y2="529.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.05"
					y1="528.28"
					x2="236.05"
					y2="569.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.05"
					y1="569.6"
					x2="210.05"
					y2="569.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.05"
					y1="569.6"
					x2="210.05"
					y2="528.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.05"
					y1="528.28"
					x2="236.05"
					y2="528.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m219.01,548.94c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26,1.01,2.26,2.26,2.26,2.26-1.01,2.26-2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="207.41 547.05 210.57 547.35 211.29 547.6 215.28 548.1 215.81 548.38 216.02 548.94 215.81 549.5 215.28 549.78 211.29 550.28 210.57 550.52 207.41 550.82 206.3 550.46 205.62 549.52 205.62 548.36 206.3 547.41 207.41 547.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="207.41"
					y1="547.05"
					x2="210.57"
					y2="547.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m210.57,547.35c.26.02.5.11.72.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.29"
					y1="547.6"
					x2="215.28"
					y2="548.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m215.28,548.1c.42.05.74.41.74.83s-.32.79-.74.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.28"
					y1="549.78"
					x2="211.29"
					y2="550.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m211.29,550.28c-.22.14-.46.22-.72.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.57"
					y1="550.52"
					x2="207.41"
					y2="550.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m207.41,550.82c-1.04,0-1.89-.84-1.89-1.89s.84-1.88,1.89-1.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.29"
					y1="549.96"
					x2="210.41"
					y2="549.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.41"
					y1="547.91"
					x2="209.29"
					y2="547.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.29"
					y1="547.91"
					x2="209.29"
					y2="549.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m210.41,547.91c.57,0,1.03.46,1.03,1.03s-.46,1.03-1.03,1.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m211.29,547.6c.45.29.73.8.73,1.33s-.27,1.04-.73,1.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="255.63 499.21 257.16 495.79 257.69 492.08 257.16 488.38 255.63 484.96 251.27 481 245.57 478.83 238.44 478.08 231.44 479.68 225.16 479.15 219.42 476.53 217.81 475.5 214.48 474.29 210.94 474.47 209.54 475.02 205.83 475.02 205.83 476.57 207.52 476.57 205.95 479.16 205.34 482.14 205.34 502.03 206.38 505.88 209.12 508.76 212.9 510 213.36 510 215.75 509.61 219.51 507.59 225.18 504.99 231.4 504.47 238.41 506.09 245.57 505.33 251.27 503.16 255.63 499.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="223.02"
					y1="484.99"
					x2="223.02"
					y2="499.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.34"
					y1="502.03"
					x2="205.34"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.06"
					y1="502.03"
					x2="206.06"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.34"
					y1="482.14"
					x2="205.34"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.06"
					y1="482.14"
					x2="206.06"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.02"
					y1="498.81"
					x2="220.38"
					y2="498.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.38"
					y1="498.81"
					x2="220.38"
					y2="496.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.38"
					y1="496.61"
					x2="223.02"
					y2="496.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.02"
					y1="485.36"
					x2="220.38"
					y2="485.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.38"
					y1="485.36"
					x2="220.38"
					y2="487.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.38"
					y1="487.55"
					x2="223.02"
					y2="487.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.41"
					y1="476.57"
					x2="205.83"
					y2="476.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.41"
					y1="475.02"
					x2="205.83"
					y2="475.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.83"
					y1="475.02"
					x2="205.83"
					y2="476.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.41"
					y1="475.02"
					x2="212.41"
					y2="476.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.69"
					y1="492.08"
					x2="257.42"
					y2="494.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.42"
					y1="494.46"
					x2="256.8"
					y2="496.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.8"
					y1="496.76"
					x2="255.63"
					y2="499.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.63"
					y1="499.21"
					x2="253.7"
					y2="501.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.7"
					y1="501.46"
					x2="251.27"
					y2="503.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.27"
					y1="503.16"
					x2="248.51"
					y2="504.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.51"
					y1="504.42"
					x2="245.57"
					y2="505.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.57"
					y1="505.33"
					x2="240.83"
					y2="506.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.83"
					y1="506.16"
					x2="238.44"
					y2="506.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.44"
					y1="506.2"
					x2="236.05"
					y2="505.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.05"
					y1="505.94"
					x2="232.36"
					y2="504.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.36"
					y1="504.86"
					x2="228.78"
					y2="503.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.78"
					y1="503.18"
					x2="225.58"
					y2="501.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.58"
					y1="501.19"
					x2="223.02"
					y2="499.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.4"
					y1="504.47"
					x2="228.08"
					y2="504.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.08"
					y1="504.49"
					x2="224.85"
					y2="505.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.85"
					y1="505.04"
					x2="221.38"
					y2="506.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.38"
					y1="506.41"
					x2="216.28"
					y2="509.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.28"
					y1="509.42"
					x2="213.74"
					y2="509.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="509.98"
					x2="211.22"
					y2="509.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.22"
					y1="509.77"
					x2="208.92"
					y2="508.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.92"
					y1="508.79"
					x2="207.07"
					y2="507.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.07"
					y1="507.05"
					x2="206.13"
					y2="505.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.13"
					y1="505.35"
					x2="205.61"
					y2="503.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="503.73"
					x2="205.34"
					y2="502.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.06"
					y1="502.03"
					x2="206.62"
					y2="504.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.62"
					y1="504.35"
					x2="207.78"
					y2="505.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.78"
					y1="505.73"
					x2="209.4"
					y2="506.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.4"
					y1="506.6"
					x2="211.54"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.54"
					y1="507.01"
					x2="213.74"
					y2="507.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="507.11"
					x2="214.83"
					y2="507.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.83"
					y1="507.09"
					x2="215.7"
					y2="506.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.7"
					y1="506.63"
					x2="215.95"
					y2="506.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.95"
					y1="506.1"
					x2="217.66"
					y2="500.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.66"
					y1="500.08"
					x2="218.17"
					y2="497.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.17"
					y1="497.09"
					x2="218.39"
					y2="494.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.39"
					y1="494.06"
					x2="218.39"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="231.44"
					y1="479.68"
					x2="228.12"
					y2="479.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.12"
					y1="479.65"
					x2="224.87"
					y2="479.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.87"
					y1="479.11"
					x2="221.38"
					y2="477.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.38"
					y1="477.76"
					x2="216.28"
					y2="474.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.28"
					y1="474.75"
					x2="214.59"
					y2="474.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.59"
					y1="474.28"
					x2="212.85"
					y2="474.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.85"
					y1="474.17"
					x2="211.14"
					y2="474.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.14"
					y1="474.42"
					x2="209.54"
					y2="475.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.06"
					y1="482.14"
					x2="206.62"
					y2="479.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.62"
					y1="479.81"
					x2="207.78"
					y2="478.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.78"
					y1="478.43"
					x2="209.4"
					y2="477.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.4"
					y1="477.57"
					x2="211.54"
					y2="477.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.54"
					y1="477.15"
					x2="213.74"
					y2="477.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="213.74"
					y1="477.06"
					x2="214.83"
					y2="477.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.83"
					y1="477.07"
					x2="215.7"
					y2="477.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.7"
					y1="477.53"
					x2="215.95"
					y2="478.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.95"
					y1="478.07"
					x2="217.66"
					y2="484.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.66"
					y1="484.09"
					x2="218.17"
					y2="487.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.17"
					y1="487.08"
					x2="218.39"
					y2="490.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.39"
					y1="490.11"
					x2="218.39"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.69"
					y1="492.08"
					x2="257.42"
					y2="489.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.42"
					y1="489.71"
					x2="256.8"
					y2="487.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.8"
					y1="487.41"
					x2="255.63"
					y2="484.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.63"
					y1="484.96"
					x2="253.7"
					y2="482.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.7"
					y1="482.71"
					x2="251.27"
					y2="481"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.27"
					y1="481"
					x2="248.51"
					y2="479.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.51"
					y1="479.74"
					x2="245.57"
					y2="478.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.57"
					y1="478.83"
					x2="240.83"
					y2="478"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.83"
					y1="478"
					x2="238.44"
					y2="477.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.44"
					y1="477.96"
					x2="236.05"
					y2="478.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.05"
					y1="478.23"
					x2="232.36"
					y2="479.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="232.36"
					y1="479.31"
					x2="228.78"
					y2="480.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="228.78"
					y1="480.98"
					x2="225.58"
					y2="482.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.58"
					y1="482.97"
					x2="223.02"
					y2="484.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.66"
					y1="508.76"
					x2="218.2"
					y2="508.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.2"
					y1="508.37"
					x2="219.01"
					y2="507.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.01"
					y1="507.28"
					x2="219.2"
					y2="506.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.2"
					y1="506.33"
					x2="219.72"
					y2="500.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.72"
					y1="500.22"
					x2="219.96"
					y2="494.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.96"
					y1="494.09"
					x2="219.96"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.66"
					y1="475.41"
					x2="218.2"
					y2="475.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.2"
					y1="475.8"
					x2="219.01"
					y2="476.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.01"
					y1="476.89"
					x2="219.2"
					y2="477.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.2"
					y1="477.84"
					x2="219.72"
					y2="483.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.72"
					y1="483.95"
					x2="219.96"
					y2="490.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.96"
					y1="490.08"
					x2="219.96"
					y2="492.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.52"
					y1="476.57"
					x2="207.07"
					y2="477.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.07"
					y1="477.12"
					x2="206.13"
					y2="478.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.13"
					y1="478.82"
					x2="205.61"
					y2="480.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.61"
					y1="480.44"
					x2="205.34"
					y2="482.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.11"
					y1="511.23"
					x2="205.34"
					y2="511.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="205.34 469.1 205.34 472.93 206.11 472.93 206.11 469.1 205.34 469.1"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="206.11"
					y1="469.1"
					x2="205.34"
					y2="469.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.11"
					y1="472.93"
					x2="206.11"
					y2="469.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.34"
					y1="472.93"
					x2="206.11"
					y2="472.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.34"
					y1="469.1"
					x2="205.34"
					y2="472.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="206.11 513.53 212.34 513.53 212.34 512.77 206.11 512.77 206.11 513.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="206.11"
					y1="512.77"
					x2="206.11"
					y2="513.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.34"
					y1="512.77"
					x2="206.11"
					y2="512.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.34"
					y1="513.53"
					x2="212.34"
					y2="512.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.11"
					y1="513.53"
					x2="212.34"
					y2="513.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="206.11 470.63 206.11 471.4 212.34 471.4 212.34 470.63 206.11 470.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="212.34"
					y1="470.63"
					x2="206.11"
					y2="470.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.34"
					y1="471.4"
					x2="212.34"
					y2="470.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.11"
					y1="471.4"
					x2="212.34"
					y2="471.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.11"
					y1="470.63"
					x2="206.11"
					y2="471.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="210.42 512.77 211.96 512.77 211.96 471.4 210.42 471.4 210.42 512.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="210.42"
					y1="471.4"
					x2="210.42"
					y2="512.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.96"
					y1="471.4"
					x2="210.42"
					y2="471.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.96"
					y1="512.77"
					x2="211.96"
					y2="471.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210.42"
					y1="512.77"
					x2="211.96"
					y2="512.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="792.27 563.79 727.6 563.79 727.6 636.57 792.27 636.57 792.27 563.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="792.27"
					y1="636.57"
					x2="792.27"
					y2="563.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.6"
					y1="636.57"
					x2="792.27"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.6"
					y1="563.79"
					x2="727.6"
					y2="636.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.27"
					y1="563.79"
					x2="727.6"
					y2="563.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.27"
					y1="568.58"
					x2="727.6"
					y2="568.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="591.18 573.16 591.18 616.86 548.23 616.86 548.23 573.16 591.18 573.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="591.18"
					y1="573.16"
					x2="591.18"
					y2="575.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.18"
					y1="578.01"
					x2="591.18"
					y2="582.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.18"
					y1="585.36"
					x2="591.18"
					y2="589.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.18"
					y1="592.71"
					x2="591.18"
					y2="597.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.18"
					y1="600.07"
					x2="591.18"
					y2="604.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.18"
					y1="607.42"
					x2="591.18"
					y2="612.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.18"
					y1="614.77"
					x2="591.18"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.18"
					y1="616.86"
					x2="589.47"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="586.71"
					y1="616.86"
					x2="582.12"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.36"
					y1="616.86"
					x2="574.76"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="572"
					y1="616.86"
					x2="567.41"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.65"
					y1="616.86"
					x2="560.05"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="557.29"
					y1="616.86"
					x2="552.7"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.94"
					y1="616.86"
					x2="548.23"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="616.86"
					x2="548.23"
					y2="614.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="612.02"
					x2="548.23"
					y2="607.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="604.66"
					x2="548.23"
					y2="600.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="597.31"
					x2="548.23"
					y2="592.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="589.95"
					x2="548.23"
					y2="585.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="582.6"
					x2="548.23"
					y2="578.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="575.25"
					x2="548.23"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.23"
					y1="573.16"
					x2="549.94"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="552.7"
					y1="573.16"
					x2="557.29"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.05"
					y1="573.16"
					x2="564.65"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.41"
					y1="573.16"
					x2="572"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.76"
					y1="573.16"
					x2="579.36"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.12"
					y1="573.16"
					x2="586.71"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.47"
					y1="573.16"
					x2="591.18"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="548.4 570.9 548.4 569.58 591.02 569.58 591.02 570.9 584.33 570.9 584.33 569.82 555.08 569.82 555.08 570.9 548.4 570.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="548.4"
					y1="570.9"
					x2="548.4"
					y2="569.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="548.4"
					y1="569.58"
					x2="591.02"
					y2="569.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="591.02"
					y1="569.58"
					x2="591.02"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="591.02"
					y1="570.9"
					x2="584.33"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="584.33"
					y1="570.9"
					x2="584.33"
					y2="569.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="584.33"
					y1="569.82"
					x2="555.08"
					y2="569.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="555.08"
					y1="569.82"
					x2="555.08"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="555.08"
					y1="570.9"
					x2="548.4"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<polyline
					points="546.73 570.9 592.69 570.9 592.69 573.16 546.73 573.16 546.73 570.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="546.73"
					y1="570.9"
					x2="592.69"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="592.69"
					y1="570.9"
					x2="592.69"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="592.69"
					y1="573.16"
					x2="546.73"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="546.73"
					y1="573.16"
					x2="546.73"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".23"
				/>
				<line
					x1="591.02"
					y1="570.9"
					x2="591.02"
					y2="569.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="591.02"
					y1="569.58"
					x2="548.4"
					y2="569.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.4"
					y1="569.58"
					x2="548.4"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.69"
					y1="570.9"
					x2="546.73"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.08"
					y1="570.9"
					x2="555.08"
					y2="569.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.08"
					y1="569.82"
					x2="584.33"
					y2="569.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.33"
					y1="569.82"
					x2="584.33"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.69"
					y1="573.16"
					x2="592.69"
					y2="570.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.73"
					y1="570.9"
					x2="546.73"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.73"
					y1="573.16"
					x2="592.69"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="652.72 569.33 652.72 619.12 710.17 619.12 710.17 569.33 652.72 569.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="652.72"
					y1="569.33"
					x2="710.17"
					y2="569.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.72"
					y1="619.12"
					x2="710.17"
					y2="619.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.72"
					y1="617.61"
					x2="710.17"
					y2="617.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.72"
					y1="569.33"
					x2="652.72"
					y2="619.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.17"
					y1="569.33"
					x2="710.17"
					y2="619.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.49"
					y1="571.59"
					x2="706.4"
					y2="571.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.4"
					y1="571.59"
					x2="707.91"
					y2="573.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.91"
					y1="573.1"
					x2="707.91"
					y2="615.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.91"
					y1="615.35"
					x2="706.4"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.4"
					y1="616.86"
					x2="656.49"
					y2="616.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="656.49"
					y1="616.86"
					x2="654.98"
					y2="615.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.98"
					y1="615.35"
					x2="654.98"
					y2="573.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.98"
					y1="573.1"
					x2="656.49"
					y2="571.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m674.62,581.78c0-4.16-3.38-7.54-7.54-7.54s-7.54,3.38-7.54,7.54,3.38,7.54,7.54,7.54,7.54-3.38,7.54-7.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m672.73,606.68c0-3.12-2.53-5.66-5.66-5.66s-5.66,2.53-5.66,5.66,2.53,5.66,5.66,5.66,5.66-2.53,5.66-5.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m701.46,581.78c0-3.12-2.53-5.66-5.66-5.66s-5.66,2.53-5.66,5.66,2.53,5.66,5.66,5.66,5.66-2.53,5.66-5.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m703.35,606.68c0-4.16-3.38-7.54-7.54-7.54s-7.54,3.38-7.54,7.54,3.38,7.54,7.54,7.54,7.54-3.38,7.54-7.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="598.2 578.67 645.9 578.67 646.97 579.11 647.41 580.17 647.41 612.11 646.97 613.18 645.9 613.62 598.2 613.62 597.14 613.18 596.69 612.11 596.69 580.17 597.14 579.11 598.2 578.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="598.2"
					y1="578.67"
					x2="645.9"
					y2="578.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m645.9,578.67c.84,0,1.51.67,1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.41"
					y1="580.18"
					x2="647.41"
					y2="612.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m647.41,612.11c0,.83-.67,1.51-1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.9"
					y1="613.62"
					x2="598.2"
					y2="613.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m598.2,613.62c-.84,0-1.51-.68-1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.69"
					y1="612.11"
					x2="596.69"
					y2="580.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m596.69,580.18c0-.84.67-1.51,1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.97"
					y1="582.44"
					x2="642.13"
					y2="582.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.64"
					y1="583.95"
					x2="643.64"
					y2="604.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.13"
					y1="606.08"
					x2="601.97"
					y2="606.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.46"
					y1="604.57"
					x2="600.46"
					y2="583.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.97"
					y1="582.44"
					x2="601.97"
					y2="582.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m642.13,582.44c.83,0,1.51.67,1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m643.64,604.57c0,.84-.68,1.51-1.51,1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m601.97,606.08c-.83,0-1.51-.67-1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m600.46,583.95c0-.83.68-1.51,1.51-1.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m624.31,598.54c0-1.25-1.01-2.26-2.26-2.26s-2.26,1.01-2.26,2.26,1.01,2.26,2.26,2.26,2.26-1.01,2.26-2.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="621.37 596.44 621.57 595.96 622.05 595.76 622.53 595.96 622.73 596.44 622.73 611.36 622.53 611.84 622.05 612.04 621.57 611.84 621.37 611.36 621.37 596.44"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m621.37,596.44c0-.37.3-.68.68-.68s.68.31.68.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.73"
					y1="596.44"
					x2="622.73"
					y2="611.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m622.73,611.36c0,.37-.31.68-.68.68s-.68-.31-.68-.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.37"
					y1="611.36"
					x2="621.37"
					y2="596.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="620.55 607.51 621.37 607.51 621.37 611.36 621.57 611.84 622.05 612.04 622.53 611.84 622.73 611.36 622.73 607.51 623.56 607.51 623.56 612.41 620.55 612.41 620.55 607.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="620.55"
					y1="607.51"
					x2="621.37"
					y2="607.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.37"
					y1="607.51"
					x2="621.37"
					y2="611.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m622.73,611.36c0,.37-.31.68-.68.68s-.68-.31-.68-.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.73"
					y1="611.36"
					x2="622.73"
					y2="607.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.73"
					y1="607.51"
					x2="623.56"
					y2="607.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="607.51"
					x2="623.56"
					y2="612.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.56"
					y1="612.41"
					x2="620.55"
					y2="612.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.55"
					y1="612.41"
					x2="620.55"
					y2="607.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="620.56 604.8 621.37 604.8 621.37 607.44 620.56 607.44 620.56 604.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="620.56"
					y1="604.8"
					x2="621.37"
					y2="604.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.37"
					y1="604.8"
					x2="621.37"
					y2="607.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.37"
					y1="607.44"
					x2="620.56"
					y2="607.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.56"
					y1="607.44"
					x2="620.56"
					y2="604.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="623.54 604.8 623.54 607.44 622.73 607.44 622.73 604.8 623.54 604.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="623.54"
					y1="604.8"
					x2="623.54"
					y2="607.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.54"
					y1="607.44"
					x2="622.73"
					y2="607.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.73"
					y1="607.44"
					x2="622.73"
					y2="604.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.73"
					y1="604.8"
					x2="623.54"
					y2="604.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.47"
					y1="598.92"
					x2="403.47"
					y2="585.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.47"
					y1="585.52"
					x2="367.08"
					y2="585.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.13"
					y1="598.92"
					x2="359.42"
					y2="598.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.42"
					y1="633.4"
					x2="411.13"
					y2="633.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.13"
					y1="633.4"
					x2="411.13"
					y2="581.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.42"
					y1="581.69"
					x2="359.42"
					y2="633.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.13"
					y1="582.65"
					x2="359.42"
					y2="582.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.08"
					y1="598.92"
					x2="367.08"
					y2="585.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.13"
					y1="581.69"
					x2="359.42"
					y2="581.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.51"
					y1="563.79"
					x2="729.51"
					y2="560.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.51"
					y1="560.01"
					x2="731.43"
					y2="560.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.43"
					y1="560.01"
					x2="731.43"
					y2="563.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.27"
					y1="573.16"
					x2="790.73"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.97"
					y1="573.16"
					x2="783.38"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.62"
					y1="573.16"
					x2="776.02"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.26"
					y1="573.16"
					x2="768.67"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.91"
					y1="573.16"
					x2="761.31"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.56"
					y1="573.16"
					x2="753.96"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.2"
					y1="573.16"
					x2="746.61"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.85"
					y1="573.16"
					x2="739.25"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.49"
					y1="573.16"
					x2="731.9"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="729.14"
					y1="573.16"
					x2="727.6"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="596.14"
					x2="546.33"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.09"
					y1="596.14"
					x2="553.68"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="556.44"
					y1="596.14"
					x2="561.04"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.79"
					y1="596.14"
					x2="568.39"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.15"
					y1="596.14"
					x2="575.75"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.5"
					y1="596.14"
					x2="583.1"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.86"
					y1="596.14"
					x2="590.45"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="593.21"
					y1="596.14"
					x2="597.81"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.57"
					y1="596.14"
					x2="605.16"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.92"
					y1="596.14"
					x2="612.51"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.27"
					y1="596.14"
					x2="619.87"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="622.63"
					y1="596.14"
					x2="627.22"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.98"
					y1="596.14"
					x2="634.58"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.34"
					y1="596.14"
					x2="641.93"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.69"
					y1="596.14"
					x2="649.29"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="652.04"
					y1="596.14"
					x2="656.64"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="659.4"
					y1="596.14"
					x2="663.99"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.75"
					y1="596.14"
					x2="671.35"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.1"
					y1="596.14"
					x2="678.7"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.46"
					y1="596.14"
					x2="686.06"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.81"
					y1="596.14"
					x2="693.41"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.17"
					y1="596.14"
					x2="700.77"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.52"
					y1="596.14"
					x2="708.12"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.88"
					y1="596.14"
					x2="715.47"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.23"
					y1="596.14"
					x2="722.82"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.58"
					y1="596.14"
					x2="727.6"
					y2="596.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="573.16"
					x2="652.72"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.17"
					y1="573.16"
					x2="727.6"
					y2="573.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.78"
					y1="286.95"
					x2="662.1"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.1"
					y1="271.63"
					x2="812.61"
					y2="271.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.28"
					y1="286.95"
					x2="418.76"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.76"
					y1="271.63"
					x2="492.28"
					y2="271.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.28"
					y1="271.63"
					x2="492.28"
					y2="286.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.73"
					y1="133.65"
					x2="251.59"
					y2="133.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.42"
					y1="118.33"
					x2="104.9"
					y2="118.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.47"
					y1="627.65"
					x2="367.08"
					y2="627.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.08"
					y1="627.65"
					x2="367.08"
					y2="602.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.08"
					y1="602.75"
					x2="403.47"
					y2="602.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.47"
					y1="602.75"
					x2="403.47"
					y2="627.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="829.18 865.39 829.18 880.71 808.49 880.71 808.49 651.89 203.42 651.89 203.42 588.75 190.02 588.75 190.02 464.69 50 464.69 50 118.33 104.9 118.33 104.9 133.65 65.32 133.65 65.32 394.18 74.48 394.18 74.48 403.75 65.32 403.75 65.32 449.38 208.38 449.38 208.38 403.75 198.01 403.75 198.01 394.18 217.95 394.18 217.95 449.38 339.03 449.38 339.03 439.26 348.61 439.26 348.61 468.56 339.03 468.56 339.03 458.95 205.34 458.95 205.34 573.43 218.73 573.43 218.73 636.57 339.03 636.57 339.03 529.84 348.61 529.84 348.61 570.7 354.64 570.7 354.64 580.29 348.61 580.29 348.61 636.57 421.94 636.57 421.94 580.29 415.91 580.29 415.91 570.7 467.19 570.7 467.19 580.29 458.4 580.29 458.4 636.57 534.74 636.57 534.74 580.29 528.47 580.29 528.47 570.7 544.32 570.7 544.32 619.12 727.6 619.12 727.6 636.57 823.81 636.57 823.81 865.39 829.18 865.39"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<rect
					x="866.07"
					y="459.78"
					width="9.58"
					height="8.07"
					fill="none"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<polygon
					points="950 444.46 950 880.71 901.96 880.71 901.96 865.39 934.68 865.39 934.68 574.66 866.07 574.66 866.07 557.62 875.65 557.62 875.65 565.08 934.68 565.08 934.68 459.78 866.07 459.78 866.07 286.95 812.62 286.95 812.62 271.62 881.4 271.62 881.4 444.46 950 444.46"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<polygon
					points="418.77 271.62 418.77 286.95 348.61 286.95 348.61 377.98 339.03 377.98 339.03 235.22 326.49 235.22 326.49 195.58 294.03 195.58 294.03 133.65 255.42 133.65 255.42 118.33 354.36 118.33 354.36 271.62 418.77 271.62"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
				<rect
					x="568.84"
					y="271.62"
					width="93.26"
					height="15.33"
					fill="none"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.04"
				/>
			</g>
			<g id="text">
				<path d="m757.13,605.5h-1.25l-1.5-2.51c-.14-.23-.27-.43-.4-.59-.13-.17-.26-.3-.4-.41-.13-.1-.28-.18-.44-.22-.15-.05-.33-.07-.52-.07h-.86v3.8h-1.05v-8.94h2.67c.39,0,.75.05,1.08.15.33.1.62.24.86.44.25.2.44.45.57.75.14.3.21.64.21,1.04,0,.31-.05.6-.14.86-.09.26-.22.49-.4.69-.17.2-.38.38-.62.52-.24.14-.51.25-.82.33v.02c.15.07.28.14.39.23.11.08.22.18.32.3.1.12.2.25.29.4.1.15.21.32.33.51l1.68,2.69Zm-5.36-8v3.24h1.42c.26,0,.5-.04.72-.12.22-.08.42-.19.58-.34.16-.15.29-.33.38-.54.09-.22.14-.46.14-.72,0-.48-.16-.85-.47-1.12-.31-.27-.75-.41-1.34-.41h-1.43Zm11.47,5.06h-4.51c.02.71.21,1.26.57,1.65s.87.58,1.51.58c.72,0,1.38-.24,1.98-.71v.96c-.56.41-1.3.61-2.23.61s-1.61-.29-2.13-.87c-.52-.58-.77-1.4-.77-2.45,0-.99.28-1.8.84-2.43.57-.63,1.27-.94,2.1-.94s1.48.27,1.94.81c.46.54.69,1.29.69,2.25v.54Zm-1.05-.87c0-.59-.15-1.05-.43-1.38-.28-.33-.67-.49-1.17-.49s-.89.17-1.23.52c-.34.35-.54.8-.62,1.35h3.45Zm5.63-4.75c-.2-.11-.43-.17-.68-.17-.72,0-1.07.45-1.07,1.35v.99h1.5v.87h-1.5v5.51h-1.02v-5.51h-1.09v-.87h1.09v-1.04c0-.67.19-1.2.58-1.58.39-.39.87-.59,1.45-.59.31,0,.56.04.74.11v.92Z" />
				<path d="m768.91,605.64c-.19,0-.36-.07-.49-.21-.13-.14-.2-.3-.2-.49s.07-.36.2-.49c.14-.14.3-.21.49-.21s.36.07.5.21c.14.14.21.3.21.49s-.07.36-.21.49c-.14.14-.3.21-.5.21Z" />
				<path d="m560.32,610.48v-8.88h3.06c.69,0,1.22.04,1.58.13.51.12.94.33,1.3.64.47.4.82.9,1.05,1.52.23.61.35,1.32.35,2.11,0,.67-.08,1.27-.24,1.79-.16.52-.36.95-.61,1.3-.25.34-.52.61-.81.81-.29.19-.64.34-1.06.44-.41.1-.89.15-1.42.15h-3.21Zm1.18-1.05h1.9c.59,0,1.04-.05,1.38-.16.34-.11.6-.26.8-.46.28-.28.49-.65.65-1.12.16-.47.24-1.04.24-1.71,0-.93-.15-1.64-.46-2.14-.3-.5-.67-.84-1.11-1.01-.32-.12-.82-.18-1.52-.18h-1.87v6.79Zm9.34,1.05l-2.36-8.88h1.21l1.35,5.82c.15.61.27,1.22.38,1.82.23-.95.36-1.5.4-1.64l1.69-6h1.42l1.27,4.5c.32,1.11.55,2.16.69,3.14.11-.56.26-1.21.44-1.93l1.39-5.71h1.18l-2.44,8.88h-1.13l-1.87-6.77c-.16-.57-.25-.91-.28-1.04-.09.41-.18.76-.26,1.04l-1.88,6.77h-1.2Z" />
				<path d="m157.76,262.56v-13.88h3.95c1.2,0,2.15.29,2.85.88.7.59,1.05,1.35,1.05,2.29,0,.79-.21,1.47-.64,2.05-.43.58-1.01.99-1.76,1.24v.04c.94.11,1.68.46,2.25,1.06.56.59.84,1.37.84,2.32,0,1.19-.43,2.15-1.28,2.88-.85.74-1.93,1.1-3.22,1.1h-4.05Zm1.63-12.41v4.48h1.66c.89,0,1.59-.21,2.1-.64.51-.43.76-1.04.76-1.82,0-1.35-.89-2.02-2.66-2.02h-1.87Zm0,5.94v4.99h2.21c.95,0,1.69-.23,2.22-.68.53-.45.79-1.07.79-1.86,0-1.64-1.12-2.46-3.35-2.46h-1.87Zm17.47,1.91h-7c.03,1.1.32,1.95.89,2.55.57.6,1.35.9,2.34.9,1.12,0,2.14-.37,3.08-1.1v1.49c-.87.63-2.02.95-3.45.95s-2.5-.45-3.3-1.35c-.8-.9-1.2-2.17-1.2-3.8,0-1.54.44-2.8,1.31-3.76.88-.97,1.96-1.46,3.26-1.46s2.3.42,3.01,1.26c.71.84,1.06,2,1.06,3.49v.83Zm-1.63-1.35c0-.92-.23-1.63-.67-2.14-.43-.51-1.04-.76-1.81-.76s-1.38.27-1.91.8-.85,1.24-.97,2.1h5.35Zm12.47,5.9h-1.59v-1.68h-.04c-.74,1.28-1.87,1.92-3.41,1.92-1.25,0-2.24-.44-2.99-1.33-.74-.89-1.11-2.1-1.11-3.63,0-1.64.41-2.95,1.24-3.94.83-.99,1.93-1.48,3.3-1.48s2.35.54,2.97,1.61h.04v-6.14h1.59v14.67Zm-1.59-4.48v-1.46c0-.8-.26-1.48-.79-2.03-.53-.55-1.2-.83-2.01-.83-.97,0-1.73.35-2.28,1.06-.55.71-.83,1.69-.83,2.94,0,1.14.26,2.05.79,2.71.54.66,1.25.99,2.15.99s1.6-.32,2.15-.96c.55-.64.83-1.45.83-2.42Zm9.96-3.82c-.28-.21-.68-.32-1.2-.32-.68,0-1.25.32-1.7.96-.45.64-.68,1.51-.68,2.61v5.05h-1.59v-9.91h1.59v2.04h.04c.23-.7.57-1.24,1.04-1.63.46-.39.98-.59,1.56-.59.41,0,.73.05.95.14v1.65Zm5.86,8.54c-1.46,0-2.64-.46-3.51-1.38-.87-.93-1.31-2.16-1.31-3.69,0-1.66.45-2.96,1.36-3.9.91-.94,2.14-1.4,3.69-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.85-1.35,3.8c-.89.95-2.09,1.42-3.59,1.42Zm.12-9.04c-1.02,0-1.83.35-2.42,1.05-.59.69-.89,1.65-.89,2.86s.3,2.1.9,2.78c.6.68,1.4,1.02,2.41,1.02s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.84s-.28-2.19-.83-2.86c-.55-.67-1.34-1.01-2.36-1.01Zm11.49,9.04c-1.46,0-2.64-.46-3.51-1.38-.87-.93-1.31-2.16-1.31-3.69,0-1.66.45-2.96,1.36-3.9.91-.94,2.14-1.4,3.69-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.85-1.35,3.8c-.89.95-2.09,1.42-3.59,1.42Zm.12-9.04c-1.02,0-1.83.35-2.42,1.05-.59.69-.89,1.65-.89,2.86s.3,2.1.9,2.78c.6.68,1.4,1.02,2.41,1.02s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.84s-.28-2.19-.83-2.86c-.55-.67-1.34-1.01-2.36-1.01Zm21.41,8.81h-1.59v-5.69c0-1.1-.17-1.89-.51-2.38-.34-.49-.9-.74-1.7-.74-.68,0-1.25.31-1.73.93-.47.62-.71,1.36-.71,2.23v5.65h-1.59v-5.88c0-1.95-.75-2.92-2.25-2.92-.7,0-1.27.29-1.72.88-.45.58-.68,1.34-.68,2.27v5.65h-1.59v-9.91h1.59v1.57h.04c.7-1.2,1.73-1.8,3.08-1.8.68,0,1.27.19,1.77.57.5.37.85.87,1.04,1.48.74-1.37,1.83-2.05,3.29-2.05,2.18,0,3.27,1.35,3.27,4.04v6.11Z" />
				<path d="m157.84,283.14h-1.15v-8.73c-.09.09-.22.19-.39.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.46.24-.16.46-.32.63-.48h.44v10.32Zm7.79,0h-1.15v-8.73c-.09.09-.22.19-.39.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.46.24-.16.46-.32.63-.48h.44v10.32Z" />
				<rect x="169.46" y="273.04" width="1.02" height="3.15" />
				<path d="m176.68,283.14h-1.15v-8.73c-.09.09-.22.19-.39.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.46.24-.16.46-.32.63-.48h.44v10.32Zm9.87-5.09c0,.84-.08,1.59-.23,2.25-.15.65-.37,1.2-.66,1.65-.29.45-.64.79-1.06,1.02-.42.23-.89.35-1.43.35-.51,0-.96-.11-1.36-.33-.39-.23-.73-.55-1-.98-.27-.43-.48-.95-.62-1.57-.14-.62-.21-1.34-.21-2.14,0-.88.07-1.66.22-2.34.15-.68.37-1.24.65-1.7.29-.46.64-.81,1.06-1.04.43-.23.92-.35,1.46-.35,2.12,0,3.18,1.73,3.18,5.18Zm-1.18.11c0-2.87-.68-4.31-2.05-4.31-1.44,0-2.16,1.46-2.16,4.39,0,2.73.71,4.09,2.12,4.09s2.09-1.39,2.09-4.17h0Z" />
				<path d="m189.32,273.04v3.15h-1.02v-3.15h1.02Zm2.34,0v3.15h-1.02v-3.15h1.02Z" />
				<path d="m203.2,275.93l-2.42,3.65,2.38,3.56h-1.35l-1.42-2.34c-.09-.15-.19-.33-.32-.55h-.03s-.13.23-.33.55l-1.44,2.34h-1.33l2.46-3.54-2.35-3.68h1.35l1.39,2.46c.1.18.2.37.3.56h.03l1.8-3.03h1.27Z" />
				<path d="m212.44,283.14h-1.15v-8.73c-.09.09-.22.19-.39.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.46.24-.16.46-.32.63-.48h.44v10.32Zm7.79,0h-1.15v-8.73c-.09.09-.22.19-.39.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.46.24-.16.46-.32.63-.48h.44v10.32Z" />
				<rect x="224.06" y="273.04" width="1.02" height="3.15" />
				<path d="m232.17,273.04v6.67h1.3v1.06h-1.3v2.37h-1.14v-2.37h-4.75v-1c.44-.5.89-1.03,1.34-1.59.45-.57.88-1.14,1.29-1.73.41-.58.79-1.16,1.14-1.74.35-.58.65-1.14.89-1.67h1.23Zm-4.58,6.67h3.44v-4.94c-.35.62-.69,1.16-1,1.65-.31.48-.62.92-.9,1.32-.28.39-.55.75-.81,1.07-.26.32-.5.62-.73.91Z" />
				<path d="m236.14,273.04v3.15h-1.02v-3.15h1.02Zm2.34,0v3.15h-1.02v-3.15h1.02Z" />
				<path d="m529.59,427.48h-7.2v-13.88h1.63v12.41h5.57v1.47Zm2.73-12.43c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.77,12.43h-1.59v-9.91h1.59v9.91Zm10.99-9.91l-3.95,9.91h-1.56l-3.75-9.91h1.74l2.52,7.2c.19.53.3.99.35,1.38h.04c.06-.5.17-.95.31-1.35l2.63-7.24h1.67Zm2.51-2.52c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.77,12.43h-1.59v-9.91h1.59v9.91Zm11.43,0h-1.59v-5.65c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.35-.77,2.25v5.65h-1.59v-9.91h1.59v1.65h.04c.75-1.25,1.83-1.88,3.25-1.88,1.08,0,1.91.35,2.49,1.05.57.7.86,1.71.86,3.03v6.06Zm11.45-.79c0,3.64-1.74,5.46-5.23,5.46-1.23,0-2.3-.23-3.21-.7v-1.59c1.12.62,2.18.93,3.19.93,2.44,0,3.66-1.3,3.66-3.89v-1.08h-.04c-.75,1.26-1.89,1.9-3.41,1.9-1.23,0-2.23-.44-2.98-1.32-.75-.88-1.12-2.07-1.12-3.55,0-1.68.4-3.02,1.21-4.02.81-.99,1.92-1.49,3.33-1.49s2.33.54,2.97,1.61h.04v-1.37h1.59v9.12Zm-1.59-3.69v-1.46c0-.79-.27-1.46-.8-2.02-.53-.56-1.19-.84-1.98-.84-.98,0-1.75.36-2.3,1.07-.55.71-.83,1.71-.83,2.99,0,1.1.26,1.99.79,2.65.54.66,1.24.99,2.12.99s1.61-.32,2.17-.95c.56-.63.84-1.44.84-2.43Z" />
				<polygon points="579.72 413.6 573.06 429.78 571.58 429.78 578.22 413.6 579.72 413.6" />
				<path d="m581.34,427.48v-13.88h3.83c4.89,0,7.34,2.25,7.34,6.76,0,2.14-.68,3.86-2.04,5.17-1.35,1.3-3.17,1.95-5.45,1.95h-3.68Zm1.63-12.41v10.94h2.07c1.82,0,3.24-.49,4.25-1.46s1.52-2.35,1.52-4.14c0-3.55-1.89-5.33-5.67-5.33h-2.17Zm12.81-.02c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.77,12.43h-1.59v-9.91h1.59v9.91Zm11.38,0h-1.59v-5.65c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.35-.77,2.25v5.65h-1.59v-9.91h1.59v1.65h.04c.75-1.25,1.83-1.88,3.25-1.88,1.08,0,1.91.35,2.49,1.05.57.7.86,1.71.86,3.03v6.06Zm3.75-12.43c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.77,12.43h-1.59v-9.91h1.59v9.91Zm11.38,0h-1.59v-5.65c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.35-.77,2.25v5.65h-1.59v-9.91h1.59v1.65h.04c.75-1.25,1.83-1.88,3.25-1.88,1.08,0,1.91.35,2.49,1.05.57.7.86,1.71.86,3.03v6.06Zm11.39-.79c0,3.64-1.74,5.46-5.23,5.46-1.23,0-2.3-.23-3.21-.7v-1.59c1.12.62,2.18.93,3.19.93,2.44,0,3.66-1.3,3.66-3.89v-1.08h-.04c-.75,1.26-1.89,1.9-3.41,1.9-1.23,0-2.23-.44-2.98-1.32-.75-.88-1.12-2.07-1.12-3.55,0-1.68.4-3.02,1.21-4.02.81-.99,1.92-1.49,3.33-1.49s2.33.54,2.97,1.61h.04v-1.37h1.59v9.12Zm-1.59-3.69v-1.46c0-.79-.27-1.46-.8-2.02-.53-.56-1.19-.84-1.98-.84-.98,0-1.75.36-2.3,1.07-.55.71-.83,1.71-.83,2.99,0,1.1.26,1.99.79,2.65.54.66,1.24.99,2.12.99s1.61-.32,2.17-.95c.56-.63.84-1.44.84-2.43Z" />
				<path d="m654.2,427.48h-1.94l-2.32-3.89c-.21-.36-.42-.67-.62-.92-.2-.26-.41-.47-.62-.63-.21-.16-.43-.28-.68-.35-.24-.08-.51-.12-.81-.12h-1.34v5.9h-1.63v-13.88h4.14c.61,0,1.16.08,1.67.23.52.15.96.38,1.34.69.38.31.68.7.89,1.16.21.46.32,1,.32,1.62,0,.48-.07.93-.22,1.34-.14.4-.35.76-.62,1.07-.26.32-.59.59-.97.81-.37.22-.8.39-1.27.51v.04c.23.1.43.22.6.36.17.13.34.28.49.46.15.18.31.39.45.62.15.23.33.49.51.79l2.6,4.17Zm-8.32-12.41v5.03h2.21c.41,0,.78-.06,1.12-.18.35-.12.65-.3.9-.52.25-.23.45-.51.59-.84.14-.34.21-.71.21-1.12,0-.74-.24-1.32-.73-1.73-.48-.42-1.17-.63-2.08-.63h-2.23Zm14.1,12.64c-1.46,0-2.64-.46-3.51-1.38-.87-.93-1.31-2.16-1.31-3.69,0-1.66.45-2.96,1.36-3.9s2.14-1.4,3.69-1.4,2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.85-1.35,3.8c-.89.95-2.09,1.42-3.59,1.42Zm.12-9.04c-1.02,0-1.83.35-2.42,1.05-.59.69-.89,1.65-.89,2.86s.3,2.1.9,2.78,1.4,1.02,2.41,1.02,1.81-.33,2.36-1c.55-.66.83-1.61.83-2.84s-.28-2.19-.83-2.86c-.55-.67-1.34-1.01-2.36-1.01Zm11.44,9.04c-1.46,0-2.64-.46-3.51-1.38-.87-.93-1.31-2.16-1.31-3.69,0-1.66.45-2.96,1.36-3.9s2.14-1.4,3.69-1.4,2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.85-1.35,3.8c-.89.95-2.09,1.42-3.59,1.42Zm.12-9.04c-1.02,0-1.83.35-2.42,1.05-.59.69-.89,1.65-.89,2.86s.3,2.1.9,2.78,1.4,1.02,2.41,1.02,1.81-.33,2.36-1c.55-.66.83-1.61.83-2.84s-.28-2.19-.83-2.86c-.55-.67-1.34-1.01-2.36-1.01Zm21.37,8.81h-1.59v-5.69c0-1.1-.17-1.89-.51-2.38-.34-.49-.9-.74-1.7-.74-.68,0-1.25.31-1.73.93-.47.62-.71,1.36-.71,2.23v5.65h-1.59v-5.88c0-1.95-.75-2.92-2.25-2.92-.7,0-1.27.29-1.72.88-.45.58-.68,1.34-.68,2.27v5.65h-1.59v-9.91h1.59v1.57h.04c.7-1.2,1.73-1.8,3.08-1.8.68,0,1.27.19,1.77.57.5.37.85.87,1.04,1.48.74-1.37,1.83-2.05,3.29-2.05,2.18,0,3.27,1.35,3.27,4.04v6.11Z" />
				<path d="m573.22,440.6c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.39-.57-.16-.15-.36-.27-.58-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.63.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.31.69-.55,1.08-.72.4-.17.89-.25,1.47-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.51.61.85.15.34.23.73.23,1.16,0,.4-.05.76-.14,1.08-.09.32-.23.63-.42.92-.18.29-.42.56-.7.82-.28.26-.61.53-.99.8-.47.34-.87.63-1.18.87-.31.24-.55.46-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.03v1.04h-6.23v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.46-.94s.5-.59.85-.89c.35-.3.78-.63,1.29-1,.37-.26.67-.51.92-.75.25-.24.45-.48.6-.72s.26-.48.32-.73c.07-.25.1-.51.1-.79Zm7.79,0c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.39-.57-.16-.15-.36-.27-.58-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.63.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.31.69-.55,1.08-.72.4-.17.89-.25,1.47-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.51.61.85.15.34.23.73.23,1.16,0,.4-.05.76-.14,1.08-.09.32-.23.63-.42.92-.18.29-.42.56-.7.82-.28.26-.61.53-.99.8-.47.34-.87.63-1.18.87-.31.24-.55.46-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.03v1.04h-6.23v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.46-.94s.5-.59.85-.89c.35-.3.78-.63,1.29-1,.37-.26.67-.51.92-.75.25-.24.45-.48.6-.72s.26-.48.32-.73c.07-.25.1-.51.1-.79Z" />
				<rect x="584.51" y="437.95" width="1.02" height="3.15" />
				<path d="m593.74,438.62c-.15.27-.34.6-.56,1-.22.4-.45.85-.69,1.35-.24.5-.49,1.03-.75,1.61-.25.57-.49,1.16-.71,1.77-.22.61-.42,1.23-.58,1.86-.16.62-.28,1.24-.36,1.85h-1.24c.08-.6.21-1.21.39-1.84.18-.63.38-1.24.6-1.85.23-.61.46-1.19.71-1.75.25-.56.49-1.07.73-1.54s.45-.88.64-1.24c.2-.36.35-.64.47-.85h-5.06v-1.04h6.42v.67Z" />
				<path d="m596.58,437.95v3.15h-1.02v-3.15h1.02Zm2.34,0v3.15h-1.02v-3.15h1.02Z" />
				<path d="m610.46,440.84l-2.42,3.65,2.38,3.56h-1.35l-1.42-2.34c-.09-.15-.19-.33-.32-.55h-.03s-.13.23-.33.55l-1.44,2.34h-1.33l2.46-3.54-2.35-3.68h1.35l1.39,2.46c.1.18.2.37.3.56h.03l1.8-3.03h1.27Z" />
				<path d="m619.7,448.05h-1.15v-8.73c-.09.09-.22.19-.39.31-.17.11-.36.23-.58.34-.21.11-.44.22-.68.32-.23.1-.46.18-.69.23v-1.17c.25-.07.52-.16.8-.28.29-.12.57-.26.84-.4.28-.15.54-.31.78-.46.24-.16.46-.32.63-.48h.44v10.32Zm8.12-7.45c0-.31-.05-.58-.15-.81-.09-.23-.23-.42-.39-.57-.16-.15-.36-.27-.58-.35-.23-.08-.47-.11-.73-.11-.23,0-.45.03-.66.09-.22.06-.43.15-.63.25-.2.11-.4.24-.59.39-.19.15-.36.32-.53.5v-1.24c.32-.31.69-.55,1.08-.72.4-.17.89-.25,1.47-.25.41,0,.8.06,1.15.18.35.12.66.29.92.52.26.23.46.51.61.85.15.34.23.73.23,1.16,0,.4-.05.76-.14,1.08-.09.32-.23.63-.42.92-.18.29-.42.56-.7.82-.28.26-.61.53-.99.8-.47.34-.87.63-1.18.87-.31.24-.55.46-.73.68-.18.21-.31.42-.38.63-.07.21-.11.45-.11.72h5.03v1.04h-6.23v-.5c0-.43.05-.81.14-1.14.09-.33.25-.64.46-.94s.5-.59.84-.89c.35-.3.78-.63,1.29-1,.37-.26.67-.51.92-.75.25-.24.45-.48.6-.72s.26-.48.32-.73c.07-.25.1-.51.1-.79Z" />
				<rect x="631.32" y="437.95" width="1.02" height="3.15" />
				<path d="m639.43,437.95v6.67h1.3v1.06h-1.3v2.37h-1.14v-2.37h-4.75v-1c.44-.5.89-1.03,1.34-1.59.45-.57.88-1.14,1.29-1.73.41-.58.79-1.16,1.14-1.74.35-.58.65-1.14.89-1.67h1.23Zm-4.58,6.67h3.44v-4.94c-.35.62-.69,1.16-1,1.65-.31.48-.62.92-.9,1.32-.28.39-.55.75-.81,1.07-.26.32-.5.62-.73.91Z" />
				<path d="m643.4,437.95v3.15h-1.02v-3.15h1.02Zm2.34,0v3.15h-1.02v-3.15h1.02Z" />
				<path d="m647.32,558.5h-2.26l-5.36-6.35c-.2-.24-.32-.4-.37-.48h-.04v6.83h-1.63v-13.88h1.63v6.52h.04c.09-.14.21-.3.37-.47l5.19-6.05h2.02l-5.95,6.66,6.37,7.22Zm2.43-12.43c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.77,12.43h-1.59v-9.91h1.59v9.91Zm7.79-.1c-.37.21-.87.31-1.48.31-1.74,0-2.6-.97-2.6-2.9v-5.86h-1.7v-1.35h1.7v-2.42l1.59-.51v2.93h2.5v1.35h-2.5v5.58c0,.66.11,1.14.34,1.42.23.28.6.43,1.12.43.4,0,.75-.11,1.04-.33v1.35Zm8.87-.36c-.76.46-1.66.69-2.71.69-1.41,0-2.55-.46-3.43-1.37-.86-.92-1.3-2.12-1.3-3.58,0-1.63.47-2.94,1.4-3.93.94-.99,2.18-1.49,3.75-1.49.87,0,1.64.16,2.3.48v1.63c-.74-.52-1.52-.77-2.36-.77-1.01,0-1.85.36-2.5,1.09-.65.72-.97,1.67-.97,2.85s.3,2.08.91,2.75c.61.67,1.43,1.01,2.46,1.01.86,0,1.68-.29,2.44-.86v1.51Zm10.62.45h-1.59v-5.71c0-2.06-.77-3.1-2.3-3.1-.77,0-1.43.3-1.95.9-.53.59-.79,1.36-.79,2.29v5.61h-1.59v-14.67h1.59v6.41h.04c.76-1.25,1.85-1.88,3.25-1.88,2.23,0,3.35,1.35,3.35,4.04v6.11Zm10.95-4.56h-7c.03,1.1.32,1.95.89,2.55.57.6,1.35.9,2.34.9,1.12,0,2.14-.37,3.08-1.1v1.49c-.87.63-2.02.95-3.45.95s-2.5-.45-3.3-1.35c-.8-.9-1.2-2.17-1.2-3.8,0-1.54.44-2.8,1.31-3.76.88-.97,1.96-1.46,3.26-1.46s2.3.42,3.01,1.26c.71.84,1.06,2,1.06,3.49v.83Zm-1.63-1.35c0-.92-.23-1.63-.67-2.14-.43-.51-1.04-.76-1.81-.76s-1.38.27-1.91.8-.85,1.24-.97,2.1h5.35Zm12.24,5.9h-1.59v-5.65c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.35-.77,2.25v5.65h-1.59v-9.91h1.59v1.65h.04c.75-1.25,1.83-1.88,3.25-1.88,1.08,0,1.91.35,2.49,1.05.57.7.86,1.71.86,3.03v6.06Z" />
				<path d="m866.15,799.12h-7.36v-13.88h7.05v1.47h-5.42v4.62h5.01v1.46h-5.01v4.86h5.73v1.47Zm10.7,0h-1.59v-5.65c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.35-.77,2.25v5.65h-1.59v-9.91h1.59v1.65h.04c.75-1.25,1.83-1.88,3.25-1.88,1.08,0,1.91.35,2.49,1.05.57.7.86,1.71.86,3.03v6.06Zm7.61-.1c-.37.21-.87.31-1.48.31-1.74,0-2.6-.97-2.6-2.9v-5.86h-1.7v-1.35h1.7v-2.42l1.59-.51v2.93h2.5v1.35h-2.5v5.58c0,.66.11,1.14.34,1.42.23.28.6.43,1.12.43.4,0,.75-.11,1.04-.33v1.35Zm7.31-8.21c-.28-.21-.68-.32-1.2-.32-.68,0-1.25.32-1.7.96-.45.64-.68,1.51-.68,2.61v5.05h-1.59v-9.91h1.59v2.04h.04c.23-.7.57-1.24,1.04-1.63.46-.39.98-.59,1.56-.59.41,0,.73.05.95.14v1.65Zm9.63-1.61l-4.56,11.5c-.81,2.05-1.95,3.08-3.43,3.08-.41,0-.76-.04-1.04-.13v-1.42c.34.12.65.17.94.17.8,0,1.4-.48,1.8-1.43l.79-1.88-3.87-9.89h1.76l2.68,7.63c.03.1.1.35.2.75h.06c.03-.15.1-.4.19-.74l2.82-7.65h1.65Z" />
				<path d="m272.02,545.69v-13.88h3.95c1.2,0,2.15.29,2.85.88.7.59,1.05,1.35,1.05,2.29,0,.79-.21,1.47-.64,2.05-.43.58-1.01.99-1.76,1.24v.04c.94.11,1.68.46,2.25,1.06.56.59.84,1.37.84,2.32,0,1.19-.43,2.15-1.28,2.88-.85.74-1.93,1.1-3.22,1.1h-4.05Zm1.63-12.41v4.48h1.66c.89,0,1.59-.21,2.1-.64.51-.43.76-1.04.76-1.82,0-1.35-.89-2.02-2.66-2.02h-1.87Zm0,5.94v4.99h2.21c.95,0,1.69-.23,2.22-.68.53-.45.79-1.07.79-1.86,0-1.64-1.12-2.46-3.35-2.46h-1.87Zm16.61,6.46h-1.59v-1.55h-.04c-.69,1.19-1.71,1.78-3.05,1.78-.99,0-1.76-.26-2.32-.78-.55-.52-.83-1.22-.83-2.08,0-1.85,1.09-2.93,3.27-3.23l2.97-.42c0-1.68-.68-2.53-2.04-2.53-1.19,0-2.27.41-3.23,1.22v-1.63c.97-.62,2.1-.93,3.37-.93,2.33,0,3.49,1.23,3.49,3.7v6.45Zm-1.59-5.01l-2.39.33c-.74.1-1.29.29-1.66.55-.37.26-.56.72-.56,1.38,0,.48.17.88.51,1.19.35.3.81.45,1.38.45.79,0,1.44-.27,1.95-.82.52-.55.77-1.25.77-2.1v-.99Zm9.18,4.92c-.37.21-.87.31-1.48.31-1.74,0-2.6-.97-2.6-2.9v-5.86h-1.7v-1.35h1.7v-2.42l1.59-.51v2.93h2.5v1.35h-2.5v5.58c0,.66.11,1.14.34,1.42.23.28.6.43,1.12.43.4,0,.75-.11,1.04-.33v1.35Zm10.35.1h-1.59v-5.71c0-2.06-.77-3.1-2.3-3.1-.77,0-1.43.3-1.95.9-.53.59-.79,1.36-.79,2.29v5.61h-1.59v-14.67h1.59v6.41h.04c.76-1.25,1.85-1.88,3.25-1.88,2.23,0,3.35,1.35,3.35,4.04v6.11Z" />
				<path d="m586.85,212.39v5.25h-1.63v-13.88h3.81c1.48,0,2.63.36,3.45,1.08.82.72,1.23,1.74,1.23,3.06s-.45,2.39-1.36,3.23c-.9.84-2.13,1.26-3.67,1.26h-1.83Zm0-7.16v5.69h1.7c1.12,0,1.98-.25,2.56-.76.59-.52.89-1.24.89-2.18,0-1.83-1.08-2.75-3.25-2.75h-1.91Zm16.22,12.41h-1.59v-1.55h-.04c-.69,1.19-1.71,1.78-3.05,1.78-.99,0-1.76-.26-2.32-.78-.55-.52-.83-1.22-.83-2.08,0-1.85,1.09-2.93,3.27-3.23l2.97-.42c0-1.68-.68-2.53-2.04-2.53-1.19,0-2.27.41-3.23,1.22v-1.63c.97-.62,2.1-.93,3.37-.93,2.33,0,3.49,1.23,3.49,3.7v6.45Zm-1.59-5.01l-2.39.33c-.74.1-1.29.29-1.66.55-.37.26-.56.72-.56,1.38,0,.48.17.88.51,1.19.35.3.81.45,1.38.45.79,0,1.44-.27,1.95-.82.52-.55.77-1.25.77-2.1v-.99Zm9.04,4.92c-.37.21-.87.31-1.48.31-1.74,0-2.6-.97-2.6-2.9v-5.86h-1.7v-1.35h1.7v-2.42l1.59-.51v2.93h2.5v1.35h-2.5v5.58c0,.66.11,1.14.34,1.42.23.28.6.43,1.12.43.4,0,.75-.11,1.04-.33v1.35Zm2.79-12.33c-.28,0-.53-.1-.73-.29-.2-.19-.3-.44-.3-.74s.1-.54.3-.74c.2-.2.44-.3.73-.3s.54.1.74.3c.21.19.31.44.31.74s-.1.53-.31.73c-.2.2-.45.3-.74.3Zm.77,12.43h-1.59v-9.91h1.59v9.91Zm7.21.23c-1.46,0-2.64-.46-3.51-1.38-.87-.93-1.31-2.16-1.31-3.69,0-1.66.45-2.96,1.36-3.9.91-.94,2.14-1.4,3.69-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.85-1.35,3.8c-.89.95-2.09,1.42-3.59,1.42Zm.12-9.04c-1.02,0-1.83.35-2.42,1.05-.59.69-.89,1.65-.89,2.86s.3,2.1.9,2.78c.6.68,1.4,1.02,2.41,1.02s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.84s-.28-2.19-.83-2.86c-.55-.67-1.34-1.01-2.36-1.01Z" />
				<polygon points="634.89 203.76 628.23 219.94 626.75 219.94 633.39 203.76 634.89 203.76" />
				<path d="m636.51,217.63v-13.88h3.95c1.2,0,2.15.29,2.85.88.7.59,1.05,1.35,1.05,2.29,0,.79-.21,1.47-.64,2.05-.43.58-1.01.99-1.76,1.24v.04c.94.11,1.68.46,2.25,1.06.56.59.84,1.37.84,2.32,0,1.19-.43,2.15-1.28,2.88-.85.74-1.93,1.1-3.22,1.1h-4.05Zm1.63-12.41v4.48h1.66c.89,0,1.59-.21,2.1-.64.51-.43.76-1.04.76-1.82,0-1.35-.89-2.02-2.66-2.02h-1.87Zm0,5.94v4.99h2.21c.95,0,1.69-.23,2.22-.68.53-.45.79-1.07.79-1.86,0-1.64-1.12-2.46-3.35-2.46h-1.87Zm16.61,6.46h-1.59v-1.55h-.04c-.69,1.19-1.71,1.78-3.05,1.78-.99,0-1.76-.26-2.32-.78-.55-.52-.83-1.22-.83-2.08,0-1.85,1.09-2.93,3.27-3.23l2.97-.42c0-1.68-.68-2.53-2.04-2.53-1.19,0-2.27.41-3.23,1.22v-1.63c.97-.62,2.1-.93,3.37-.93,2.33,0,3.49,1.23,3.49,3.7v6.45Zm-1.59-5.01l-2.39.33c-.74.1-1.29.29-1.66.55-.37.26-.56.72-.56,1.38,0,.48.17.88.51,1.19.35.3.81.45,1.38.45.79,0,1.44-.27,1.95-.82.52-.55.77-1.25.77-2.1v-.99Zm6.17,5.01h-1.59v-14.67h1.59v14.67Zm9.96-.45c-.76.46-1.66.69-2.71.69-1.41,0-2.55-.46-3.43-1.37-.86-.92-1.3-2.12-1.3-3.58,0-1.63.47-2.94,1.4-3.93.94-.99,2.18-1.49,3.75-1.49.87,0,1.64.16,2.3.48v1.63c-.74-.52-1.52-.77-2.36-.77-1.01,0-1.85.36-2.5,1.09-.65.72-.97,1.67-.97,2.85s.3,2.08.91,2.75c.61.67,1.43,1.01,2.46,1.01.86,0,1.68-.29,2.44-.86v1.51Zm6.54.69c-1.46,0-2.64-.46-3.51-1.38-.87-.93-1.31-2.16-1.31-3.69,0-1.66.45-2.96,1.36-3.9.91-.94,2.14-1.4,3.69-1.4s2.63.45,3.45,1.36c.83.91,1.25,2.17,1.25,3.78s-.45,2.85-1.35,3.8c-.89.95-2.09,1.42-3.59,1.42Zm.12-9.04c-1.02,0-1.83.35-2.42,1.05-.59.69-.89,1.65-.89,2.86s.3,2.1.9,2.78c.6.68,1.4,1.02,2.41,1.02s1.81-.33,2.36-1c.55-.66.83-1.61.83-2.84s-.28-2.19-.83-2.86c-.55-.67-1.34-1.01-2.36-1.01Zm15.58,8.81h-1.59v-5.65c0-2.1-.77-3.15-2.3-3.15-.79,0-1.45.3-1.97.9-.52.59-.77,1.35-.77,2.25v5.65h-1.59v-9.91h1.59v1.65h.04c.75-1.25,1.83-1.88,3.25-1.88,1.08,0,1.91.35,2.49,1.05.57.7.86,1.71.86,3.03v6.06Zm10.88-9.91l-4.56,11.5c-.81,2.05-1.95,3.08-3.43,3.08-.41,0-.76-.04-1.04-.13v-1.42c.34.12.65.17.94.17.8,0,1.4-.48,1.8-1.43l.79-1.88-3.87-9.89h1.76l2.68,7.63c.03.1.1.35.2.75h.06c.03-.15.1-.4.19-.74l2.82-7.65h1.65Z" />
				<path d="m384.16,611.63l-2.5,8.83h-1.21l-1.82-6.46c-.08-.28-.13-.58-.14-.9h-.02c-.02.3-.08.6-.16.89l-1.83,6.47h-1.2l-2.59-8.83h1.14l1.88,6.78c.08.28.13.58.15.89h.03c.02-.22.08-.51.19-.89l1.95-6.78h.99l1.87,6.83c.07.23.11.51.15.83h.02c.02-.21.07-.5.17-.85l1.81-6.8h1.12Z" />
				<polygon points="389.32 611.63 385.08 621.93 384.13 621.93 388.36 611.63 389.32 611.63" />
				<path d="m390.34,620.46v-8.83h2.44c3.11,0,4.67,1.44,4.67,4.31,0,1.36-.43,2.46-1.3,3.29-.86.83-2.02,1.24-3.47,1.24h-2.34Zm1.04-7.9v6.96h1.32c1.16,0,2.06-.31,2.7-.93.64-.62.97-1.5.97-2.64,0-2.26-1.2-3.39-3.61-3.39h-1.38Z" />
			</g>
		</g>
	)
}

export default PlanLL
